<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <onaydialog ref="onaydialog"></onaydialog>
    <hatadialog ref="hatadialog"></hatadialog>
    <faturaheaderdialog ref="faturaheaderdialog"></faturaheaderdialog>

    <v-form ref="formgelenfatura" v-model="validform" lazy-validation>
      <v-card flat color="grey lighten-5">
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{sayfabaslik}}</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-btn :disabled="faturagoster" @click="iadeFaturaYazdir()" flat> <span class="hidden-sm-and-down">
                 {{ $t('Find-Invoice-Template') }} </span>
                <v-icon right dark>insert_drive_file</v-icon>
              </v-btn>

            

              <v-btn @click="Yazdir()" v-if="yazdirbtngoster" flat> <span class="hidden-sm-and-down"> {{ $t('Print') }} </span>
                <v-icon right dark>print</v-icon>
              </v-btn>



              <v-menu bottom left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>



                  <v-tooltip bottom>
                    <v-list-tile slot="activator" :disabled="faturagoster" @click="faturaTaslakSil()">
                      <v-list-tile-title> {{ $t('Delete-Invoice-Template') }} </v-list-tile-title>
                    </v-list-tile>
                    <span> {{ $t('Delete-Invoice-Template') }} </span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <v-list-tile :disabled="faturagoster" slot="activator" @click="yeniSablonEkle()">
                      <v-list-tile-title>Yeni Şablon Ekle</v-list-tile-title>
                    </v-list-tile>
                    <span>Yeni Şablon Ekle</span>
                  </v-tooltip>
                  <v-tooltip bottom  v-show="faturagoster" >
                    <v-list-tile slot="activator" @click="faturaSablonSil()">
                      <v-list-tile-title> {{ $t('Delete-Selected-Template') }} </v-list-tile-title>
                    </v-list-tile>
                    <span>Fatura Şablon Sil</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <v-list-tile :disabled="faturagoster" slot="activator" @click="faturaSablonDuzenle()">
                      <v-list-tile-title> {{ $t('Edit-Selected-Template') }} </v-list-tile-title>
                    </v-list-tile>
                    <span> {{ $t('Edit-Selected-Template') }} </span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <v-list-tile :disabled="faturagoster" slot="activator" @click="faturaSablonDipDuzenle()">
                      <v-list-tile-title>{{  $t('Edit-Bottom-Explanation-Selected-Template') }}</v-list-tile-title>
                    </v-list-tile>
                    <span> {{ $t('Edit-Selected-Template') }} </span>
                  </v-tooltip>


                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container v-if="!dizaynView && !faturagoster" fluid>

            <v-layout row wrap>

              <v-flex pa-1 xs12 sm12 md4>
                <v-flex mt-2 xs12 sm12 md12>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>

                            <tarihcomp :aktifmi="true" :etiket="$t('Refund-Invoice-Date')" :detaygizle="true"
                              :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                              v-bind:value="IadeFatura.Fatura.GelenFaturaTarihi"
                              v-model="IadeFatura.Fatura.GelenFaturaTarihi">
                            </tarihcomp>


                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-layout>
                              <v-flex xs12 sm6 md6>
                                <v-text-field :disabled="seridisable" :label="$t('Invoice-Serial-No-v2')" hide-details
                                  :rules="[v => !!v || $t('Mandatory-Areas'), () => !!IadeFatura.Fatura.IadeFaturaBilgisi.GelenFaturaSeri && IadeFatura.Fatura.IadeFaturaBilgisi.GelenFaturaSeri.length <= 3|| $t('Cannot-exceed-three-characters')]"
                                  v-model="IadeFatura.Fatura.IadeFaturaBilgisi.GelenFaturaSeri"></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm6 md6>
                                <v-text-field hide-details="" mask="#########" :disabled="seridisable" :label="$t('Invoice-No')"
                                  v-model="IadeFatura.Fatura.IadeFaturaBilgisi.GelenFaturaNo"
                                  :rules="[v => !!v || $t('Mandatory-Areas')]">
                                </v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-text-field v-model="IadeFatura.Fatura.IadeFaturaBilgisi.CariReferans" hide-details=""
                              :label="$t('Current-Reference')" value="">
                            </v-text-field>
                          </v-flex>


                          <v-flex xs12 sm12 md12>
                            <geneltipara tip="CariTransferKod" v-model="IadeFatura.Fatura.TransferKod"></geneltipara>
                          </v-flex>

                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-flex>

              <v-flex pa-1 mt-2 xs12 sm6 md4>

                <v-card flat class="white--text">
                  <v-card flat="">
                    <v-card-actions>
                      <v-layout row wrap>
                        <v-layout row wrap>


                          <v-flex xs12 sm6 md6>
                            <v-autocomplete :items="doviztipi" hide-details="" item-text="Title" item-value="DovizKod"
                              v-model="IadeFatura.Fatura.FatPara" @change="kurgetir2()" :label="$t('Invoice-Money')">
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <dovizinput v-model="IadeFatura.Fatura.FatKur" :etiket="$t('Invoice-Exchange-Rate')"
                              ::autocomplete="autocomplete">
                            </dovizinput>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]"
                              v-model="IadeFatura.Fatura.IadeFaturaBilgisi.IadeNedeni" maxlength="99" hide-details=""
                              label="İade Nedeni" value="">
                            </v-text-field>
                          </v-flex>


                        </v-layout>


                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>

              <v-flex pa-1 xs12 mt-2 sm6 md4>
                <v-flex xs12 sm12 md12>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-form ref="formfatura" v-model="valid" lazy-validation>

                          <v-layout row wrap>
                            <v-flex xs12 sm12>

                              <v-layout row wrap>
                                <v-flex md12 xs12 sm12>
                                  <v-select :items="itemsBelgeTipi" v-model="IadeFatura.FaturaKesimOzellik.Tip"
                                    :label="$t('File-Type')" hide-details="" item-text="text" item-value="id">
                                  </v-select>
                                </v-flex>

                                <v-flex md12 xs12 sm12>
                                  <v-select :items="itemsFaturaTipi" v-model="IadeFatura.FaturaKesimOzellik.FaturaTip"
                                    :label="$t('Invoice-Type')" hide-details="" item-text="text" item-value="id">
                                  </v-select>
                                </v-flex>


                                <v-flex md12 xs12 sm12>
                                  <v-select :items="itemsFaturaSablon" :rules="[v => !!v || $t('Mandatory-Areas')]"
                                    v-model="faturaSablon" :label="$t('Invoice-Template')" hide-details="">
                                  </v-select>
                                </v-flex>
                                <!--
                                <v-flex md12 pt-2 xs2 sm12>
                                  <v-btn block outline @click="iadeFaturaYazdir(pnr)" color="info">
                                    <v-icon small>insert_drive_file</v-icon> {{ $t('Find-Invoice-Template') }}
                                  </v-btn>
                                </v-flex> -->

                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-form>

                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>



              </v-flex>

            </v-layout>

            <v-flex mt-2 xs12 sm12 md12>
              <v-card color="grey lighten-5" flat="">
                <v-card-actions>
                  <v-layout row wrap>

                    <v-flex xs12 sm12 md12>
                      <v-layout row wrap>

                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap class=" project overdue">
                            <v-toolbar flat="" size="120px" dark color="white">
                              <v-toolbar-title> <span class="subheading black--text">
                                   {{ $t('Added-Lines') }} 
                                </span> </v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-btn color="grey" @click="satirekle()" flat>Satır Ekle
                                <v-icon color="grey" right dark>add_box</v-icon>
                              </v-btn>
                            </v-toolbar>
                          </v-layout>
                        </v-flex>
                        <v-flex pl-2 v-if="IadeFatura.Fatura.Kalemler.length==0" xs12 sm12 md12>
                          <span class="grey--text ">Henüz kayıt eklemediniz</span>
                        </v-flex>

                        <v-flex v-for="item in IadeFatura.Fatura.Kalemler" pt-1 v-bind:key="item.id" xs12 sm12 md12>
                          <v-layout class=" project overdue">
                            <v-hover>
                              <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`"
                                width="100%">


                                <v-list two-line="">
                                  <v-layout row wrap>
                                    <v-flex xs12 sm12 md12>
                                      <v-card flat class="black--text">
                                        <v-card flat="">
                                          <v-card-actions>
                                            <v-layout row wrap>

                                              <v-flex xs12 sm4 md2>
                                                <v-layout
                                                  v-show="$vuetify.breakpoint.md || $vuetify.breakpoint.sm  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                                                  align-center justify-start fill-height>
                                                  <v-card flat="">
                                                    <v-list-tile>
                                                      <v-list-tile-content>
                                                        <v-layout row align-center justify-start>


                                                          <v-chip small="" color="pink" text-color="white">
                                                            <v-avatar>
                                                              <v-icon color="white">hotel</v-icon>
                                                            </v-avatar>
                                                            Coper
                                                          </v-chip>
                                                        </v-layout>

                                                        <v-list-tile-sub-title>
                                                          <div class="font-weight-bold  "> Pnr No:
                                                            {{item.PNR_No}}
                                                          </div>
                                                        </v-list-tile-sub-title>

                                                      </v-list-tile-content>
                                                    </v-list-tile>
                                                  </v-card>
                                                </v-layout>

                                              </v-flex>


                                              <v-flex xs6 sm2 md2>
                                                <v-layout>
                                                  <v-flex xs12 sm6 md6>
                                                    <v-layout align-start="" justify-start fill-height>
                                                      <v-card flat="">
                                                        <v-list-tile>
                                                          <v-list-tile-content style="'overflow=inherit';">

                                                            <v-list-tile-sub-title>
                                                              <div class="font-weight-bold caption ">
                                                                {{ $t('Amount') }}
                                                              </div>
                                                            </v-list-tile-sub-title>


                                                            <v-list-tile-sub-title>
                                                              <div class="font-weight-bold caption ">
                                                                {{ $t('VAT-Amount') }} :
                                                              </div>
                                                            </v-list-tile-sub-title>

                                                            <v-list-tile-sub-title>
                                                              <div class="font-weight-bold caption ">
                                                                Konaklama Vergisi :
                                                              </div>
                                                            </v-list-tile-sub-title>

                                                          </v-list-tile-content>
                                                        </v-list-tile>
                                                      </v-card>
                                                    </v-layout>
                                                  </v-flex>

                                                  <v-flex xs12 sm6 md6>
                                                    <v-layout row justify-end="" fill-height>
                                                      <v-card flat="">
                                                        <v-list-tile>
                                                          <v-list-tile-content>

                                                            <v-list-tile-sub-title>
                                                              <v-layout align-center="" justify-end>
                                                                <div class="font-weight-  caption ">
                                                                  {{item.Tutar | moneyformat}}{{getparabirimi()}}</div>
                                                              </v-layout>
                                                            </v-list-tile-sub-title>

                                                            <v-list-tile-sub-title>
                                                              <v-layout align-center="" justify-end>
                                                                <div class="font-weight-  caption ">
                                                                  {{item.KDVTutar | moneyformat}}{{getparabirimi()}}
                                                                </div>
                                                              </v-layout>
                                                            </v-list-tile-sub-title>

                                                            <v-list-tile-sub-title>
                                                              <v-layout align-center="" justify-end>
                                                                <div class="font-weight-  caption ">
                                                                  {{item.EkVergiTutar | moneyformat}}{{getparabirimi()}}
                                                                </div>
                                                              </v-layout>
                                                            </v-list-tile-sub-title>

                                                          </v-list-tile-content>
                                                        </v-list-tile>
                                                      </v-card>
                                                    </v-layout>
                                                  </v-flex>
                                                </v-layout>
                                              </v-flex>


                                              <v-flex xs6 sm2 md2>
                                                <v-layout>
                                                  <v-flex xs12 sm6 md6>
                                                    <v-layout align-start="" justify-start fill-height>
                                                      <v-card flat="">
                                                        <v-list-tile>
                                                          <v-list-tile-content style="'overflow=inherit';">

                                                            <v-list-tile-sub-title>
                                                              <div class="font-weight-bold caption ">
                                                                 {{ $t('Deduction-Rate') }} :
                                                              </div>
                                                            </v-list-tile-sub-title>

                                                            <v-list-tile-sub-title>
                                                              <div class="font-weight-bold  caption">
                                                                  {{  $t('Deduction-Amount') }}
                                                              </div>
                                                            </v-list-tile-sub-title>

                                                          </v-list-tile-content>
                                                        </v-list-tile>
                                                      </v-card>
                                                    </v-layout>
                                                  </v-flex>

                                                  <v-flex xs12 sm6 md6>
                                                    <v-layout row justify-end="" fill-height>
                                                      <v-card flat="">
                                                        <v-list-tile>
                                                          <v-list-tile-content>

                                                            <v-list-tile-sub-title>
                                                              <v-layout align-center="" justify-end>
                                                                <div class="font-weight-  caption ">
                                                                  {{item.TevkifatOran | orangoster}}%</div>
                                                              </v-layout>
                                                            </v-list-tile-sub-title>

                                                            <v-list-tile-sub-title>
                                                              <v-layout align-center="" justify-end="">
                                                                <div class="font-weight-  caption ">
                                                                  {{item.TevkifatTutar | moneyformat}}{{getparabirimi()}}
                                                                </div>
                                                              </v-layout>
                                                            </v-list-tile-sub-title>

                                                          </v-list-tile-content>
                                                        </v-list-tile>
                                                      </v-card>
                                                    </v-layout>
                                                  </v-flex>
                                                </v-layout>
                                              </v-flex>

                                              <v-flex xs12 sm4 md2>
                                                <v-layout row align-center justify-center="" fill-height="">
                                                  <v-card flat="">
                                                    <v-list-tile>
                                                      <v-list-tile-content>
                                                        <v-layout row wrap justify-center="">
                                                          <v-list-tile-title>
                                                            <v-layout row wrap justify-center="">
                                                              KDV'li Tutar
                                                            </v-layout>
                                                          </v-list-tile-title>
                                                          <v-list-tile-sub-title>
                                                            <v-layout row wrap justify-center="">
                                                              <div class="red--text subheading">
                                                                {{item.KDVliTutar | moneyformat}}{{getparabirimi()}}

                                                              </div>
                                                            </v-layout>

                                                          </v-list-tile-sub-title>
                                                          <v-list-tile-title>
                                                            <v-layout row wrap justify-center="">
                                                              <div class="font-weight green--text caption ">
                                                                % {{item.KDVYuzde | moneyformat}} {{ $t('VAT') }}
                                                              </div>
                                                            </v-layout>

                                                          </v-list-tile-title>
                                                        </v-layout>
                                                      </v-list-tile-content>

                                                    </v-list-tile>
                                                  </v-card>
                                                </v-layout>
                                              </v-flex>

                                              <v-flex xs12 sm4 md2>
                                                <v-layout row align-center justify-center="" fill-height="">
                                                  <v-card flat="">
                                                    <v-list-tile>
                                                      <v-list-tile-content>
                                                        <v-layout row wrap justify-center="">
                                                          <v-list-tile-title>
                                                            <v-layout row wrap justify-center="">
                                                              {{$t('Net-Amount')}}
                                                            </v-layout>
                                                          </v-list-tile-title>
                                                          <v-list-tile-sub-title>
                                                            <v-layout row wrap justify-center="">
                                                              <div class="red--text subheading">
                                                                {{(item.KDVliTutar-item.TevkifatTutar+item.EkVergiTutar) | moneyformat}}{{getparabirimi()}}

                                                              </div>
                                                            </v-layout>

                                                          </v-list-tile-sub-title>
                                                          <v-list-tile-title>
                                                            <v-layout row wrap justify-center="">
                                                              <div class="font-weight green--text caption ">
                                                                &nbsp;
                                                              </div>
                                                            </v-layout>

                                                          </v-list-tile-title>
                                                        </v-layout>
                                                      </v-list-tile-content>

                                                    </v-list-tile>
                                                  </v-card>
                                                </v-layout>
                                              </v-flex>

                                              <v-flex xs12 sm4 md2>
                                                <v-card flat="">
                                                  <v-layout row wrap align-center="" justify-end="" fill-height="">

                                                    <v-flex xs2 sm2 md2>
                                                      <v-tooltip slot="append" bottom>
                                                        <v-btn slot="activator" icon class="mx-0"
                                                          @click="satirsil(item)">
                                                          <v-icon color="red">delete</v-icon>
                                                        </v-btn>
                                                        <span> {{ $t('Delete') }} </span>
                                                      </v-tooltip>
                                                    </v-flex>

                                                    <v-flex xs2 sm2 md2>
                                                      <v-tooltip slot="append" bottom>
                                                        <v-btn slot="activator" icon class="mx-0"
                                                          @click="satirduzenle(item)">
                                                          <v-icon color="green">edit</v-icon>
                                                        </v-btn>
                                                        <span>Düzenle</span>
                                                      </v-tooltip>
                                                    </v-flex>

                                                  </v-layout>
                                                </v-card>
                                              </v-flex>

                                            </v-layout>
                                          </v-card-actions>
                                        </v-card>
                                      </v-card>
                                    </v-flex>
                                  </v-layout>

                                </v-list>
                              </v-card>
                            </v-hover>
                          </v-layout>
                        </v-flex>

                      </v-layout>
                    </v-flex>

                  </v-layout>

                </v-card-actions>
              </v-card>
            </v-flex>


          </v-container>

          <v-flex xs12 v-if="dizaynView && dizaynViewType==1 && !faturagoster" pa-2 sm12 md12>

            <v-flex xs12 pa-2 sm12 md12>
              <v-card flat>

                <v-layout row wrap>
                  <v-flex xs6 sm6 md6>
                    <v-layout fill-height row align-center>
                      <span pa-1 class=" font-weight-regular grey--text title"> &nbsp; 
                        {{ $t('Edit-Template-Item-Explanation') }}
                      </span>
                    </v-layout>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                    <v-layout justify-end>
                      <v-btn color="info" slot="activator" @click="iptal()" flat>
                        <span class="hidden-sm-and-down"> {{$t("cancel_button")}}
                        </span>
                        <v-icon right dark>cancel</v-icon>
                      </v-btn>
                      <v-tooltip bottom>
                        <v-btn :disabled="!sayfayetki.Update" color="info" slot="activator" @click="kalemDizaynKaydet()"
                          flat>
                          <span class="hidden-sm-and-down">  {{ $t('Update-Design') }} 
                          </span>
                          <v-icon right dark>save</v-icon>
                        </v-btn>
                        <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                        <span v-if="sayfayetki.Update"> {{ $t('Update-Design') }} </span>
                      </v-tooltip>

                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>

            </v-flex>

            <v-layout row wrap>

              <v-flex xs9 pa-2 md9 sm9>
                <v-form ref="formsaticidizayn" v-model="valid2" lazy-validation>
                  <v-card flat>
                    <v-layout row wrap>
                      <v-flex pa-2 md3 xs3 sm12>
                        <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="faturaSablon" :label="$t('Template-Name')"
                          hide-details="">
                        </v-text-field>
                      </v-flex>

                      <v-flex pa-2 md3 xs3 sm12>
                        <v-select :items="itemssaticitipi" item-text="Aciklama" item-value="Kod"
                          v-model="Dizayn.SaticiTip" :label="$t('Seller-Type')" hide-details="">
                        </v-select>
                      </v-flex>
                      <v-flex pa-2 md3 xs3 sm12>
                        <v-select :items="xsltitems" :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="dizaynData.XsltId"
                          clearable item-text="XsltAciklama" item-value="FaturaId" :label="$t('Select-xslt-File')"></v-select>
                      </v-flex>

                      <v-flex pa-2 md3 xs3 sm12>
                        <reportbrosablon :rules="[v => !!v || $t('Mandatory-Areas')]" ref="reportbrosablon"
                          dizayngrupadi="Fatura" v-model="dizaynData.ReportBroId"
                          objectname="Controllers.ReportBro.Invoice.InvoicePrint"></reportbrosablon>
                      </v-flex>

                      <v-flex pa-2 xs12 md12 sm12>
                        <v-textarea v-if="dizaynView" rows="10" :label="$t('Invoice-Explanation-Template')"
                          v-model="dizaynData.KalemAciklamaSablonu[kayitvarmi].AciklamaSablonu" id="textalan"
                          name="textalan" hide-details=""></v-textarea>
                      </v-flex>
                    </v-layout>

                  </v-card>
                </v-form>
              </v-flex>

              <v-flex xs3 pa-2 md3 sm3>
                <v-card flat>
                  <v-flex xs12 md12 sm12>
                    <draggable element="span" v-model="dizaynData.KalemAciklamaFieldList" v-bind="dragOptions"
                      :move="onMove">
                      <transition-group name="no" class="list-group" tag="ul">
                        <v-list v-for="element in dizaynData.KalemAciklamaFieldList" :key="element.FieldName" subheader>
                          <v-list-tile>
                            <v-flex xs12 md12 sm12>
                              <v-icon @click="ItemAktar(element.FieldName)" color="green">arrow_back_ios
                              </v-icon>
                              <span class="grey--text subheading"> {{element.FieldName}}</span>
                            </v-flex>
                            <v-list-tile-action>
                              <v-btn icon ripple>
                                <v-icon color="grey">drag_handle
                                </v-icon>
                              </v-btn>
                            </v-list-tile-action>
                          </v-list-tile>
                          <v-divider></v-divider>
                        </v-list>
                      </transition-group>
                    </draggable>

                  </v-flex>
                </v-card>
              </v-flex>
            </v-layout>

          </v-flex>

          <v-flex xs12 v-if="dizaynView && dizaynViewType==2 && !faturagoster" pa-2 sm12 md12>

            <v-flex xs12 pa-2 sm12 md12>
              <v-card flat>

                <v-layout row wrap>
                  <v-flex xs6 sm6 md6>
                    <v-layout fill-height row align-center>
                      <span pa-1 class=" font-weight-regular grey--text title"> &nbsp;
                         {{ $t('Edit-Template-Item-Explanation') }}
                      </span>
                    </v-layout>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                    <v-layout justify-end>
                      <v-btn color="info" slot="activator" @click="iptal()" flat>
                        <span class="hidden-sm-and-down"> {{$t("cancel_button")}}
                        </span>
                        <v-icon right dark>cancel</v-icon>
                      </v-btn>
                      <v-tooltip bottom>
                        <v-btn :disabled="!sayfayetki.Update" color="info" slot="activator" @click="kalemDizaynKaydet()"
                          flat>
                          <span class="hidden-sm-and-down">  {{ $t('Update-Design') }} 
                          </span>
                          <v-icon right dark>save</v-icon>
                        </v-btn>
                        <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                        <span v-if="sayfayetki.Update"> {{ $t('Update-Design') }} </span>
                      </v-tooltip>

                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>

            </v-flex>

            <v-layout row wrap>

              <v-flex xs9 pa-2 md9 sm9>
                <v-form ref="formsaticidizayn" v-model="valid2" lazy-validation>
                  <v-card flat>
                    <v-flex pa-2 md4 xs4 sm4>
                      <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="faturaSablon" :label="$t('Template-Name')"
                        hide-details="">
                      </v-text-field>
                    </v-flex>

                    <v-flex pa-2 xs12 md12 sm12>
                      <v-textarea v-if="dizaynView" rows="10" :label="$t('Invoice-Bottom-Explanation-Template')"
                        v-model="dizaynData.DipAciklamaSablonu" id="textalanDip" name="textalanDip" hide-details="">
                      </v-textarea>
                    </v-flex>
                  </v-card>
                </v-form>
              </v-flex>

              <v-flex xs3 pa-2 md3 sm3>
                <v-card flat>
                  <v-flex xs12 md12 sm12>
                    <draggable element="span" v-model="dizaynData.DipAciklamaFieldList" v-bind="dragOptions"
                      :move="onMove">
                      <transition-group name="no" class="list-group" tag="ul">
                        <v-list v-for="element in dizaynData.DipAciklamaFieldList" :key="element.FieldName" subheader>
                          <v-list-tile>
                            <v-flex xs12 md12 sm12>
                              <v-icon @click="ItemAktarDip(element.FieldName)" color="green">arrow_back_ios
                              </v-icon>
                              <span class="grey--text subheading"> {{element.FieldName}}</span>
                            </v-flex>
                            <v-list-tile-action>
                              <v-btn icon ripple>
                                <v-icon color="grey">drag_handle
                                </v-icon>
                              </v-btn>
                            </v-list-tile-action>
                          </v-list-tile>
                          <v-divider></v-divider>
                        </v-list>
                      </transition-group>
                    </draggable>

                  </v-flex>
                </v-card>
              </v-flex>
            </v-layout>

          </v-flex>

          <v-flex v-if="faturagoster==true" xs10 pa-2 sm10>
            <v-card flat>
              <v-layout justify-end row wrap>

                <v-flex xs12 pa-3 sm12>

                  <div id="printJS-form">

                    <table style="page-break-after: always;" width="100%">

                      <tr>

                        <td colspan=8 align=center style="padding-top:10px;padding-bottom:10px;">
                          <span class="black--text title">FATURA</span>
                        </td>
                      </tr>

                      <tr>

                        <td colspan="8">
                          <v-layout class="no-print" justify-end>
                            <v-btn color="info" flat @click="baslikGuncelle()">
                              <v-icon small>edit</v-icon> &nbsp; {{$t('Edit-Header-Information')}}
                            </v-btn>
                          </v-layout>

                          <br />
                          <br />

                        </td>
                      </tr>
                      <tr style="align-top:40;" align=left>
                        <td align="left" style="width:35%">
                          <span class=".subheading font-weight-bold">
                            {{faturaitems.Musteri.Unvan1}}</span>
                        </td>

                        <td style="width:30%">
                        </td>

                        <td style="width:20%">
                          &nbsp;
                        </td>

                        <td style="text-align:end; width:10%" align=left>
                          <span class=".subtitle-2 font-weight-bold">
                            {{faturaitems.FaturaTarihi | dateformat}} </span>

                        </td>

                      </tr>

                      <tr>
                        <td>
                          <span class="subheading font-weight-bold">
                            {{faturaitems.Musteri.Unvan2}}</span>

                        </td>
                        <td>

                        </td>
                        <td style="text-align:end;">
                          {{$t('Maturity-Date')}} : </td>
                        <td style="text-align:end;">
                          <span class=".subtitle-2 font-weight-">
                            {{faturaitems.VadeTarihi | dateformat}} </span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="body-2 font-weight-regular">
                            {{faturaitems.Musteri.Adres1}}</span>

                        </td>
                        <td>

                        </td>
                        <td style="text-align:end;">
                          Fatura S/N:
                        </td>
                        <td style="text-align:end;">
                          {{faturaitems.FaturaSeri}}- {{faturaitems.FaturaNo}}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="body-2 font-weight-regular">
                            {{faturaitems.Musteri.Adres2}}&nbsp;
                          </span>
                        <td>

                        </td>
                        <td>

                        </td>
                        <td>

                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="body-2 font-weight-regular">
                            {{faturaitems.Musteri.Ilce_Il}} </span>
                        <td>

                        </td>
                        <td>

                        </td>
                        <td>

                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="body-2 font-weight-regular">
                            {{faturaitems.Musteri.VergiDairesi}}/
                            {{faturaitems.Musteri.VergiNo_TCKimlikNo}} </span>
                        <td>

                        </td>
                        <td>

                        </td>
                        <td>

                        </td>
                      </tr>
                      <tr>
                        <td>
                          <br />
                          <br />
                          <br /> <br />

                        </td>
                      </tr>

                      <tr style="padding-top:50px;" v-for="item in faturaitems.Kalemler" :key="item.id">
                        <td colspan=4>
                          <table width="100%">
                            <tr colspan=4>
                              <td style="margin-top:20px;">

                                <span class="  subheading"> {{item.Aciklama}}</span>
                                <v-icon class="no-print" small @click="EditSatirAciklama(item)">
                                  edit
                                </v-icon>
                              </td>

                              <td style="width:10%">
                                <span class="  subheading"> </span>
                              </td>
                              <td style="width:20%">
                                <span class="  subheading"> </span>
                              </td>
                              <td style="text-align:end;width:10%">
                                <span class="  subheading">
                                  {{item.Tutar | moneyformat}}&nbsp;₺</span>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <td colspan=4>
                          <table width="100%">
                            <tr colspan=4>
                              <td style="margin-top:20px;">
                                <span class="  subheading"> </span>
                                <v-divider></v-divider>
                              </td>

                              <td style="width:10%">
                                <span class="  subheading"> </span>
                                <v-divider></v-divider>
                              </td>
                              <td style="width:40%">
                                <v-divider></v-divider>
                              </td>
                              <td style="text-align:end;width:10%">
                                <v-divider></v-divider>

                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <td colspan=4>
                          <table width="100%">
                            <tr colspan=4>
                              <td style="margin-top:20px;">
                                <span class="  subheading"> </span>
                              </td>

                              <td style="width:10%">
                                <span class="  subheading"> </span>
                              </td>
                              <td style="width:40%">
                                <span class="  subheading">   {{ $t('Detail-Total') }}  : </span>
                              </td>
                              <td style="text-align:end;width:10%">
                                <span class="  subheading">
                                  {{faturaitems.Toplamlar.Tutar | moneyformat}}&nbsp;₺</span>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr v-for="itemiskonto in faturaitems.Toplamlar.IskontoToplamlari" :key="itemiskonto.id">
                        <td colspan=4>
                          <table width="100%">
                            <tr colspan=4>
                              <td style="margin-top:20px;">
                                <span class="  subheading"> </span>
                              </td>

                              <td style="width:10%">
                                <span class="  subheading"> </span>
                              </td>
                              <td style="width:40%">
                                <span class="  subheading"> %{{itemiskonto.KDVOrani}} &nbsp;
                                  {{ $t('Discount') }}   
                                </span>
                              </td>
                              <td style="text-align:end;width:10%">
                                <span class="  subheading">
                                  {{itemiskonto.Tutar | moneyformat}}&nbsp;₺</span>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr v-for="itemiskdv in faturaitems.Toplamlar.KDVToplamlari" :key="itemiskdv.id">
                        <td colspan=4>
                          <table width="100%">
                            <tr colspan=4>
                              <td style="margin-top:20px;">
                                <span class="  subheading"> </span>
                              </td>

                              <td style="width:10%">
                                <span class="  subheading"> </span>
                              </td>
                              <td style="width:40%">
                                <span class="  subheading"> %{{itemiskdv.KDVOrani}} &nbsp;
                                  KDV Matrah: {{itemiskdv.Matrah | moneyformat}} </span>
                              </td>
                              <td style="text-align:end;width:10%">
                                <span class="  subheading">
                                  {{itemiskdv.KDVTutari | moneyformat}}&nbsp;₺</span>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr v-for="item in faturaitems.Toplamlar.EkVergiToplamlari" :key="item.id">
                        <td colspan=4>
                          <table width="100%">
                            <tr colspan=4>
                              <td style="margin-top:20px;">
                                <span class="  subheading"> </span>
                              </td>

                              <td style="width:10%">
                                <span class="  subheading"> </span>
                              </td>
                              <td style="width:40%">
                                <span class="  subheading"> %{{item.VergiOrani}} &nbsp;
                                  Konaklama Vergisi: {{item.Matrah | moneyformat}} </span>
                              </td>
                              <td style="text-align:end;width:10%">
                                <span class="  subheading">
                                  {{item.VergiTutari | moneyformat}}&nbsp;₺</span>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>


                      <tr>
                        <td colspan=4>
                          <table width="100%">
                            <tr colspan=4>
                              <td style="margin-top:20px;">
                                <span class="  subheading"> </span>
                              </td>

                              <td style="width:10%">
                                <span class="  subheading"> </span>
                              </td>
                              <td style="width:40%">
                                <v-divider></v-divider>
                              </td>
                              <td style="text-align:end;width:10%">
                                <v-divider></v-divider>

                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <td colspan=4>
                          <table width="100%">
                            <tr colspan=4>
                              <td style="margin-top:20px;">
                                <span class="  subheading"> </span>
                              </td>

                              <td style="width:10%">
                                <span class="  subheading"> </span>
                              </td>
                              <td style="width:40%">
                                <span class="  subheading">  {{ $t('Grand-Total') }} : </span>
                              </td>
                              <td style="text-align:end;width:10%">
                                <span class="  subheading">
                                  {{faturaitems.Toplamlar.NetTutar | moneyformat}}&nbsp;₺</span>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <br />
                          <br />

                        </td>
                      </tr>

                      <tr style="padding-top:20px;margin-top:10px;">

                        <td colspan=4>
                          <table width="100%">
                            <tr v-for="itemsaciklama in faturaitems.DipAciklamalar" :key="itemsaciklama.id">
                              <td>

                                {{itemsaciklama.Aciklama}}
                                <v-icon small class="no-print" @click="EditSatirAciklama2(itemsaciklama)">
                                  edit
                                </v-icon>
                              </td>
                              <td>
                              </td>
                              <td>

                              </td>

                            </tr>

                          </table>
                        <td>

                        </td>

                      </tr>

                      <tr>
                        <td colspan="8">
                          <span class="grey--text caption"> {{getDateNow() | dateformat}}
                            {{getdatetimenow()}}</span>
                        </td>
                      </tr>

                    </table>
                  </div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

          <v-flex v-if="faturagoster==true" xs2 pa-2 sm2>
            <v-card flat>
              <v-layout row wrap>

                <v-flex xs12 pa-3 sm12>
                  <v-layout row wrap>

                    <v-flex xs12 sm12>
                      <v-btn block v-if="faturagoster" :disabled="!faturagoster" @click="FaturaTaslakUpdate()"
                        :loading="loading" color="info" outline>
                        <v-icon small>check_circle_outlinef</v-icon>  {{ $t('Invoice-the-Template') }} 
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12>
                      <v-btn block v-if="faturagoster" :disabled="!faturagoster" @click="denemeyazdir('printJS-form')"
                        color="info" outline>
                        <v-icon small>print</v-icon> {{ $t('Print') }}
                      </v-btn>

                    </v-flex>
                    <v-flex xs12 sm12>
                      <v-btn block v-if="faturagoster" :disabled="!faturagoster" @click="faturagoster=false"
                        color="info" outline>
                        Geri
                      </v-btn>

                    </v-flex>

                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>


        </v-layout>
      </v-card>
    </v-form>





    <v-dialog v-model="satirdialog" scrollable="" persistent="" max-width="650px">
      <v-card color="grey lighten-5">
        <v-card-title> {{ $t('Line-Entry') }} </v-card-title>
        <v-divider></v-divider>
        <v-card-text>

          <v-layout row wrap="">
            <v-flex v-if="itemskalemler.length==0" xs12 sm12 md12>
              <v-alert type="error" value="true">
                <span> Herhangi bir kalem bulunamadı</span>
              </v-alert>
            </v-flex>

            <v-flex xs12 pb-2 sm12 md12>
              <v-card flat class="white--text">
                <v-card flat="">
                  <v-card-actions>

                    <v-layout row wrap>
                      <v-flex xs12 pb-2 sm12 md12>

                        <v-select hide-details
                          :rules="[v => !!v.PNR_No || $t('Code-cannot-left-blank'), v => v.PNR_No != '0' || 'Kod tanımlanmamış.']"
                          :items="itemskalemler" v-model="secilenKalem" label="Kalem Seçimi">
                          <template slot="selection" slot-scope="{ item }">
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md2>

                                  <v-layout align-center fill-height row wrap>
                                    <v-chip v-if="item.SaticiTip==1" small="" color="white" text-color="pink">
                                      <v-icon color="pink">hotel</v-icon>
                                    </v-chip>

                                    <v-chip v-if="item.SaticiTip==2" small="" color="orange" text-color="white">
                                      <v-icon color="white">rv_hookup</v-icon>
                                    </v-chip>


                                    <v-chip v-if="item.SaticiTip==3" small="" color="deep-purple" text-color="white">
                                      <v-icon color="white">restaurant</v-icon>
                                    </v-chip>

                                    <v-chip v-if="item.SaticiTip==4" small="" color="yellow accent-4"
                                      text-color="white">
                                      <v-icon color="white">local_see</v-icon>
                                    </v-chip>


                                    <v-chip v-if="item.SaticiTip==5" small="" color="green" text-color="white">
                                      <v-icon color="white">departure_board</v-icon>
                                    </v-chip>



                                    <v-chip v-if="item.SaticiTip==6" small="" color="teal accent-4" text-color="white">
                                      <v-icon color="white">emoji_people</v-icon>
                                    </v-chip>



                                    <v-chip v-if="item.SaticiTip==7" small="" color="orange" text-color="white">
                                      <v-icon color="white">museum</v-icon>
                                    </v-chip>


                                    <v-chip v-if="item.SaticiTip==8" small="" color="blue darken-4" text-color="white">
                                      <v-icon color="white">flight_takeoff</v-icon>
                                    </v-chip>



                                    <v-chip v-if="item.SaticiTip==9" small="" color="cyan darken-2" text-color="white">
                                      <v-icon color="white">directions_boat</v-icon>
                                    </v-chip>


                                    <v-chip v-if="item.SaticiTip==10" small="" color="pink" text-color="white">
                                      <v-icon color="white">category</v-icon>
                                    </v-chip>


                                    <v-chip v-if="item.SaticiTip==11" small="" color="brown" text-color="white">
                                      <v-icon color="white">style</v-icon>
                                    </v-chip>




                                    <v-chip v-if="item.SaticiTip==12" small="" color="deep-purple" text-color="white">
                                      <v-icon color="white">style</v-icon>
                                    </v-chip>



                                    <v-chip v-if="item.SaticiTip==13" small="" color="info" text-color="white">
                                      <v-icon color="white">style</v-icon>
                                    </v-chip>



                                    <v-chip v-if="item.SaticiTip==14" small="" color="lime" text-color="white">
                                      <v-icon color="white">verified_user</v-icon>
                                    </v-chip>



                                    <v-chip v-if="item.SaticiTip==15" small="" color="blue" text-color="white">
                                      <v-icon color="white">directions_boat</v-icon>
                                    </v-chip>






                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm12 md3>
                                  <v-layout align-center fill-height row wrap>
                                    <span class="grey--text body-1"> {{ item.Satici.isim}} </span>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm12 md3>

                                  <v-layout row justify-center align-center fill-height wrap>
                                    <v-flex xs12 sm12 md12>
                                      <span class="grey--text body-1"> {{ item.Donem1 | dateformat }} </span>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                      <span class="grey--text body-1"> {{ item.Donem2 | dateformat }} </span>
                                    </v-flex>



                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md2>
                                  <v-layout row justify-center align-center fill-height wrap>


                                    <v-flex xs12 sm12 md12>
                                      <v-layout row justify-center fill-height wrap>
                                        <v-icon color="red" small>person</v-icon> &nbsp; <span
                                          class="body-1 grey--text">
                                          {{ item.KisiIsim  }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm12 pr-2 md2>
                                  <v-layout row align-center fill-height justify-end wrap>
                                    <span class="grey--text body-1"> {{ item.KalemMaliyet | moneyformat}}
                                      {{ item.MaliyetParaBirimi }}</span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                          </template>

                          <template slot="item" slot-scope="data">

                            <v-layout row wrap>
                              <v-flex xs12 pr-2 sm12 md1>
                                <v-layout align-center fill-height row wrap>



                                  <v-chip v-if="data.item.Satici.tip==1" small="" color="white" text-color="pink">
                                    <v-icon color="pink">hotel</v-icon>
                                  </v-chip>

                                  <v-chip v-if="data.item.Satici.tip==2" small="" color="orange" text-color="white">
                                    <v-icon color="white">rv_hookup</v-icon>
                                  </v-chip>


                                  <v-chip v-if="data.item.Satici.tip==3" small="" color="deep-purple"
                                    text-color="white">
                                    <v-icon color="white">restaurant</v-icon>
                                  </v-chip>

                                  <v-chip v-if="data.item.Satici.tip==4" small="" color="yellow accent-4"
                                    text-color="white">
                                    <v-icon color="white">local_see</v-icon>
                                  </v-chip>


                                  <v-chip v-if="data.item.Satici.tip==5" small="" color="green" text-color="white">
                                    <v-icon color="white">departure_board</v-icon>
                                  </v-chip>



                                  <v-chip v-if="data.item.Satici.tip==6" small="" color="teal accent-4"
                                    text-color="white">
                                    <v-icon color="white">emoji_people</v-icon>
                                  </v-chip>



                                  <v-chip v-if="data.item.Satici.tip==7" small="" color="orange" text-color="white">
                                    <v-icon color="white">museum</v-icon>
                                  </v-chip>


                                  <v-chip v-if="data.item.Satici.tip==8" small="" color="blue darken-4"
                                    text-color="white">
                                    <v-icon color="white">flight_takeoff</v-icon>
                                  </v-chip>



                                  <v-chip v-if="data.item.Satici.tip==9" small="" color="cyan darken-2"
                                    text-color="white">
                                    <v-icon color="white">directions_boat</v-icon>
                                  </v-chip>


                                  <v-chip v-if="data.item.Satici.tip==10" small="" color="pink" text-color="white">
                                    <v-icon color="white">category</v-icon>
                                  </v-chip>


                                  <v-chip v-if="data.item.Satici.tip==11" small="" color="brown" text-color="white">
                                    <v-icon color="white">style</v-icon>
                                  </v-chip>


                                  <v-chip v-if="data.item.Satici.tip==12" small="" color="deep-purple"
                                    text-color="white">
                                    <v-icon color="white">style</v-icon>
                                  </v-chip>

                                  <v-chip v-if="data.item.Satici.tip==13" small="" color="info" text-color="white">
                                    <v-icon color="white">style</v-icon>
                                  </v-chip>

                                  <v-chip v-if="data.item.Satici.tip==14" small="" color="lime" text-color="white">
                                    <v-icon color="white">verified_user</v-icon>
                                  </v-chip>

                                  <v-chip v-if="data.item.Satici.tip==15" small="" color="blue" text-color="white">
                                    <v-icon color="white">directions_boat</v-icon>
                                  </v-chip>

                                </v-layout>
                              </v-flex>


                              <v-flex xs12 pr-2 sm12 md2>
                                <v-layout align-center fill-height row wrap>
                                  <span class="grey--text caption"> {{ data.item.Satici.isim}} </span>
                                </v-layout>
                              </v-flex>



                              <v-flex pl-2 xs12 sm12 md2>

                                <v-layout row wrap>
                                  <v-flex xs12 sm12 md12>
                                    <span class="caption"> {{ data.item.Donem1 | dateformat }} </span>
                                  </v-flex>

                                  <v-flex xs12 sm12 md12>
                                    <span class="caption"> {{ data.item.Donem2 | dateformat }}</span>
                                  </v-flex>

                                </v-layout>

                              </v-flex>


                              <v-flex pl-1 xs12 sm12 md3>

                                <v-layout row wrap>

                                  <v-flex xs12 sm6 md6>
                                    <v-layout row wrap>

                                      <v-flex xs12 sm12 md12>
                                        <span class="caption"> {{ $t('Amount') }}: </span>
                                      </v-flex>

                                      <v-flex xs12 sm12 md12>
                                        <span class="caption"> {{$t('Currency-Amount')}}:</span>
                                      </v-flex>

                                    </v-layout>

                                  </v-flex>

                                  <v-flex xs12 sm6 md6>
                                    <v-layout row align-end fill-height wrap>

                                      <v-flex xs12 sm12 md12>
                                        <v-layout row align-end fill-height justify-end column wrap>
                                          <span class="caption"> {{ data.item.KalemMaliyet | moneyformat }} </span>
                                        </v-layout>
                                      </v-flex>

                                      <v-flex xs12 sm12 md12>
                                        <v-layout row align-end fill-height justify-end column wrap>
                                          <span class="caption"> {{ data.item.MaliyetDoviz | moneyformat }}</span>
                                        </v-layout>
                                      </v-flex>

                                    </v-layout>

                                  </v-flex>

                                </v-layout>

                              </v-flex>


                              <v-flex pl-1 xs12 sm12 md2>
                                <v-layout row justify-center align-end fill-height wrap>

                                  <v-flex xs12 sm12 md12>
                                    <v-layout row justify-center align-end fill-height wrap>
                                      <span class="caption"> {{$t('Currentcode_label')}}</span>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm12 md12>
                                    <v-layout row justify-center align-end fill-height wrap>
                                      <span class="caption"> {{ data.item.Satici.CariKod  }} </span>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex pl-1 xs12 sm12 md2>
                                <v-layout row justify-center align-center fill-height wrap>


                                  <v-flex xs12 sm12 md12>
                                    <v-layout row justify-center fill-height wrap>
                                      <v-icon color="red" small>person</v-icon> <span class="caption">
                                        {{ data.item.KisiIsim  }}
                                      </span>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                            </v-layout>




                          </template>

                        </v-select>
                      </v-flex>

                    </v-layout>

                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>




            <v-flex xs12 sm12 md12>
              <v-card flat class="white--text">
                <v-card flat="">
                  <v-card-actions>

                    <v-layout row wrap>


                      <v-flex xs12 sm6 md6>
                        <parainputevents :simge="getparabirimi()" @odakkaybi="tutarblur" v-model="kalemData.Tutar"
                          :etiket="'Tutar'" :autocomplete="autocomplete">
                        </parainputevents>
                      </v-flex>

                      <v-flex xs12 sm6 md6>
                        <yuzdeinput v-model="kalemData.KDVYuzde" :etiket="'KDV %'"></yuzdeinput>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <coperkdvkodu v-model="kdvkodu"></coperkdvkodu>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <coperistisnakodu v-model="istisnakodu"></coperistisnakodu>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <copertevkifatkodu v-model="tevkifatkodu"></copertevkifatkodu>
                      </v-flex>

                      <v-flex xs12 sm6 md6>
                        <yuzdeinput v-model="kalemData.EkVergiYuzde" :etiket="'Ek Vergi %'"></yuzdeinput>
                      </v-flex>

                    </v-layout>

                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>




          </v-layout>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="satirdialog=false">{{$t("cancel_button")}}</v-btn>

          <v-btn v-if="satirbuton" color="blue darken-1" flat @click.native="satirkaydet()">{{ $t('Add') }}</v-btn>

          <v-btn v-if="!satirbuton" color="blue darken-1" flat @click.native="satirguncellekaydet()">{{ $t('Update') }}
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="yeniSablonDialog" max-width="450px">
      <v-card>
        <v-card-text>
          <v-container>
            <v-form ref="formyenisablon" v-model="validyenisablon" lazy-validation>
              <v-layout row wrap>
                <v-flex xs12 md12 sm12>
                  <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" hide-details v-model="yeniSablonAdi"
                    :label="$t('Template-Name')"></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" flat="flat" @click.native="yeniSablonDialog = false">{{$t("cancel_button")}}</v-btn>
          <v-btn color="info" flat @click.native="yeniSablonKaydet()">{{$t("save_button")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="SatirDialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-container>

            <v-text-field v-model="editedItem.Aciklama" :label="$t('Invoice-Line')"></v-text-field>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="SatirDialog2" max-width="500px">
      <v-card>
        <v-card-text>
          <v-container>
            <v-text-field v-model="editedItem2.Aciklama" :label="$t('Bottom-line-Explanation')"></v-text-field>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>




    <v-dialog v-model="loadingdialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t('Your-process-progress')}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogsor" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('Warning') }} !</v-card-title>
        <v-card-text>Bu kayıtı silmek istediğinize emin misiniz?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" flat @click.native="dialogsor=false">{{$t("cancel_button")}}</v-btn>
          <v-btn v-if="faturasilbtn" color="info" flat @click="faturasil()">{{ $t('OK') }}</v-btn>

          <v-btn v-if="satirsilbtn" color="info" flat @click="satirsil()">{{ $t('OK') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>

<script>
  import auth from '../../../api/auth'
  import parainputevents from '../customcomp/parainputevents'
  import dovizinput from '../customcomp/dovizinput'
  import yuzdeinput from '../customcomp/yuzdeinput'
  import tarihcomp from '../customcomp/tarihim'
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
  import geneltiplist from "@/components/app/customcomp/geneltiplist.vue"
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import onaydialog from "@/components/app/customcomp/onaydialog.vue"
  import rez from "../coper/rezervasyon";
  import genelarama from "@/components/app/coper/comp/genelarama.vue";
  import pnrbul from "@/components/app/coper/component/pnrbul.vue";
  import muhasebefistipara from "@/components/app/coper/component/muhasebefistipara.vue";
  import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
  import tool from "../coper/tools";
  import coperkdvkodu from "@/components/app/coper/component/kdvkoducomp.vue";
  import copertevkifatkodu from "@/components/app/coper/component/copertevkifatkodu.vue";
  import coperistisnakodu from "@/components/app/coper/component/coperistisnakodu.vue";



  import printJS from 'print-js'
  import kur from "@/components/app/coper/comp/kur.vue";
  import genelaramakod from "@/components/app/coper/comp/genelaramakod.vue";
  import draggable from "vuedraggable";
  import reportbrosablon from "@/components/app/coper/comp/reportbrosablon.vue";
  import webadresicomp from "@/components/app/bilet/partpage/webadresicomp.vue"
  import odemesekillericomp from "@/components/app/bilet/partpage/odemesekillericomp.vue"
  import odemearacicomp from "@/components/app/bilet/partpage/odemearacicomp.vue"
  import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
  import faturaheaderdialog from "@/components/app/coper/comp/faturaheaderdialog.vue";


  export default {
    props: {
      operation: ''
    },
    computed: {

      draggingInfo() {
        return this.dragging ? "under drag" : "";
      },

      dragOptions() {
        return {
          animation: 0,
          group: "description",
          disabled: !this.editable,
          ghostClass: "ghost"
        };
      },
      listString() {
        return JSON.stringify(this.list, null, 2);
      },
      list2String() {
        return JSON.stringify(this.list2, null, 2);
      }
    },

    data() {
      return {
        itemsFaturaTipi: [{
            id: 0,
            text: this.$t('Summarize-Per-Current-Code')
          },
          {
            id: 1,
            text: 'PNR Noya Göre Özet'
          },
          {
            id: 2,
            text: this.$t('Summarize-Per-Sales-Item')
          }, {
            id: 3,
            text: this.$t('Details')
          }, {
            id: 4,
            text: this.$t('Summarize-Per-Seller-Type')
          }, {
            id: 5,
            text: this.$t('Summarize-per-Seller-Code')
          }
        ],

        itemsBelgeTipi: [{
            id: 0,
            text: this.$t("Bill"),
          },
          // {
          //   id: 1,
          //   text: this.$t('Receipt')
          // },
          // {
          //   id: 2,
          //   text: 'Proforma'
          // },
           {
            id: 3,
            text: this.$t('E-Invoice')
          }
        ],
        itemsFaturaSablon: [],
        faturaSablon: null,
        validyenisablon: true,
        yeniSablonAdi: null,
        yeniSablonDialog: false,
        dizaynView: false,
        Dizayn: {
          AciklamaSablonu: '',
          SaticiTip: 1,
          ReportBroId: null,
          XsltId: null
        },
        valid2: true,
        itemssaticitipi: rez.SaticiTip,
        kayitvarmi: 0,
        isDragging: false,
        delayedDragging: false,
        dragging: false,
        dizaynData: [],
        dizaynAdi: null,
        editable: true,
        id: 3,
        name: "handle",
        display: "Handle",
        faturaitems: [],
        faturagoster: false,
        itemskalemler: [],
        istisnakodu: {
          id: null,
          intField: null,
          isim: null,
          kod: null,
          tip: null
        },
        kdvkodu: {
          id: null,
          intField: null,
          isim: null,
          kod: null,
          tip: null
        },
        tevkifatkodu: {
          id: null,
          intField: null,
          isim: null,
          kod: null,
          tip: null
        },
        secilenKalem: {
          PNR_No: null,
        },
        kalemData: {
          KDVYuzde: 0,
          Tutar: 0,
          KDVliTutar: 0,
          KDVTutar: 0,
          PNR_No: null,
          IslemRef: null,
          TevkifatOran: 0,
          TevkifatTutar: 0,
          KdvID: null,
          KdvMuafiyetID: null,
          TevkifatID: null,
          EkVergiTutar:0,
          EkVergiYuzde:0
        },

        Aciklamalar: {
          Aciklama1: null,
          Aciklama2: null,
          Not: null
        },
        SatirDialog: false,
        editedItem: {},
   
        SatirDialog2: false,
        editedItem2: {},

        kalemkayitvarmi: true,
        pnrkalemloading: false,
        loadingdialog1: true,
        pnretiket: null,
        pnrtip: true,
        islemtipi: 0,
        duzenlenenkayitindex: -1,
        kalemdialog: false,
        secilenkayitlar: [],
        itemsgelen: [],
        blurevents: null,
        itemssaticitip: rez.SaticiTip,

        IadeFatura: {
          Fatura: {
            IadeFaturaBilgisi: {
              GelenFaturaSaticiTip: null,
              GelenFaturaSaticiKod: null,
              GelenFaturaNo: null,
              GelenFaturaSeri: null,
              GelenFaturaTarihi: null,
              CariReferans: "Fatura İadesi. Cari Referans",
              IadeNedeni: " Fatura İadesi"
            },
            Kalemler: [],
            FatPara: "TL",
            FatKur: 1,
            TransferKod: null,
            ToplamTutar: 0,
            ToplamKDVliTutar: 0,
            ToplamKDVTutar: 0,
            ToplamTevkifatTutar: 0,
            FaturaNetTutar: 0,
            ToplamEkVergiTutar: 0,
            
          },
          FaturaKesimOzellik: {
            Tip: 0,
            FaturaTur: 0,
            FaturaTip: 2,
            KesimTip: 3
          },
          Sablon: "A1"
        },
        satirbuton: true,
        yenibaslikBilgi: {
          rez: null,
          FaturaKesimOzellik: {},
          KesimTip: null,
          Id: null,
          GrupId: null,
          FaturaNo: null,
          FaturaSeri: null,
          FaturaTarihi: null,
          VadeTarihi: null,
          ParaBirimi: null,

          Musteri: {
            Unvan1: null,
            Unvan2: null,
            Adres1: null,
            Adres2: null,
            VergiDairesi: null,
            VergiNo_TCKimlikNo: null,
            Ilce_Il: null,
            CariKod: null,
            PerFirstName: null,
            PerFamilyName: null,
            EMail: null,

          },
          Toplamlar: null,
          DipAciklamalar: [],
          Kalemler: [],
          TopluFaturaId: null,
          GenelFaturaId: null,
          Kur: null,
          ReportBroId: null,
          XsltId: null,
          EArsiv: {
            gonderimSekli: null,
            internetSatisBilgi: {
              odemeAracisiAdiID: null,
              odemeSekli: null,
              odemeSekliDigerAciklamaID: null,
              odemeTarihi: null,
              webAdresiID: null
            }
          },
          IadeFatura: {}
        },
        manuelSeri: false,
        itemsfaturaseri: [],
        validearsiv: true,
        validdigeraciklama: true,

        EArsivBilgiClass: {
          tip: 0,
          gonderimSekli: '0',
          internetSatisBilgi: {
            odemeAracisiAdiID: null,
            odemeSekli: null,
            odemeSekliDigerAciklamaID: null,
            odemeTarihi: null,
            webAdresiID: null
          }
        },
        taslakIdItems: [],













        GelenFatura: {
          KayitTipi: 1,
          Fatura: {
            SaticiTip: 1,
            SaticiKod: null,
            FatSeri: null,
            FatNo: null,
            FatTarih: null,
            FatPara: 'TL',
            FatKur: 1,
            SatisPara: 'TL',
            SatisKur: 1,
            VadeTarihi: null,
            HesaplananVade: null,
            FaturaTip: 0,
            MasrafMrkz: null,
            Proforma: false,
            Aciklama: null,
            MuhasebeFisTipi: {
              id: null,
              kod: null,
              isim: null,
              tip: null
            },
            TransferKod: {
              id: null,
              kod: null,
              isim: null,
              tip: null
            },
            Kalemler: [],

            ToplamTuta: 0,
            ToplamKDVliTutar: 0,
            ToplamKDVTutar: 0,
            ToplamEkVergiTutar:0,
            ToplamTevkifatTutar: 0,
            ToplamStopajTutar: 0,
            FaturaNetTutar: 0,
            Satici: {
              id: null,
              kod: null,
              isim: null,
              tip: null,
              YurtIci_YurtDisi: 0,
              CariKod: null,
              KDV: 0,
            }
          },
          EskiFatura: {
            SaticiTip: null,
            SaticiKod: null,
            FatSeri: null,
            FatNo: null,
            FatTarih: null,
          }
        },

        SatirGelenFatura: {
          PnrNo: null,
          KDVYuzde: 0,
          Tutar: 0,
          KDVTutar: 0,
          KDVliTutar: 0,
          TevkifatTutar: 0,
          TevkifatOran: 0,
          StopajTutar: 0,
          StopajOran: 0,
          MatrahToplam: 0,
          TutarToplam: 0,
          KDVToplam: 0,
          TevkifatToplam: 0,
          EkVergiTutar:0,
          EkVergiYuzde:0
        },
        Kalem: {
          KDVYuzde: 0,
          Tutar: 0,
          KDVliTutar: 0,
          KDVTutar: 0,
          PNR_No: null,
          TevkifatOran: 0,
          TevkifatTutar: 0,
          StopajOran: 0,
          StopajTutar: 0,
          IslemRef: null,
          EkVergiTutar:0,
          EkVergiYuzde:0
        },
        headerspnr: [{
            text: 'Satıcı Tip',
            value: 'kod'
          },
          {
            text: this.$t('Description'),
            value: 'aciklama',

          }
        ],
        kodmesajı: null,
        progress: false,
        items: [],
        aranacakkelime: null,
        secilendeger: null,
        dialog: false,


        iadevalid: true,
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },

        degisenkayit: null,
        dizayngoster: true,
        yazdirbtngoster: false,
        efaturatipi: [{
            text: this.$t('Commercial'),
            value: '0'
          },
          {
            text: this.$t('Basic'),
            value: '1'
          },
          {
            text: this.$t('Export'),
            value: '2'
          }
        ],
        silinecekkayit: null,
        dialogsor: false,
        efaturatipigecici: 0,
        webadresilabel: null,
        odemeseklilabel: null,
        odemesekliaciklamalabel: null,
        odemearacilabel: null,
        odemetarihilabel: null,
        internetsatislabel: null,
        gonderimlabel: null,

        valid: true,
              
        reportbroview: false,
       
        validform: true,
        gibserigoster: true,
        autocomplete: 'autocomplete',
        drawer: null,
        baslik: '',
        e1: 0,
        Code: '',
        e2: true,
        yok: false,
        statesecili: [{
          Kod: 'Kod',
          Unvan: 'Unvan',
          newProp: 'Kod' + ' - ' + 'Unvan'
        }],
        statecari: [],
        secilensatirno: -1,
        
        
        loading: false,
        caritext: '',
        cariid: '',
        aktifdate: false,
        nefaturasi: 'serbest',

        SerbestFatura: {
          SirketKodu: '',
          SerbestFaturaDetay: [],
          Serbest: true,
          AlisSatis: false,
          FaturaSeri: '',
          FaturaNo: '',
          Update: false,
          FaturaTip: 0, // 0 : Satış faturası , 1 : Iade Faturası
          Evrak: {
            Evrakkod: ''
          },
          Cari: {
            Kod: ''
          },
          EFaturaBilgi: {
            Unvani: '',
            Unvani2: '',
            Adres1: '',
            Adres2: '',
            IlceSehir: '',
            Email: '',
            VergiDairesi: '',
            VergiNo: '',
            TcKimlikNo: '',
            Adi: '',
            Soyadi: '',
            TUnvani: '',
            DigerAdi: '',
            OnAdiEki: '',
          },
          Tarih: null,
          GibSeri: '',
          Vade: null,
          Referans: {
            Kod: ''
          },
          Masraf: {
            Code: ''
          },
          Aciklama: '',
          Doviz: {
            DovizKod: ''
          },
          FTimeStamp:null,
          FaturaUnique:null,
          Kur: 0,
          TevkivatKdv: 0,
          FaturaID: 0,
          CariAktarma: false,
          Tutarlar: {
            ToplamTutar: 0,
            Iskonto: 0,
            FaturaToplam: 0,
            Kdv: 0,
            TevkifatKdv: 0
          },
          Efaturakayit: false,
          Earchiveakayit: false,
          Kagitfatura: false,
          EarsivBilgi: {
            GonderimSekli: '',
            InternetSatis: '',
            pWebAdresi: '',
            OdemeSekli: '',
            OdemeSekliAciklama: '',
            OdemeAraci: '',
            OdemeTarihi: ''
          },
          EFaturaShowID: {
            EFaturaID: null,
            EFaturaGuid: null,
            FaturaStatus: null,
            PdfID: null,
            DizaynID: null,
            XsltID: null

          },
          IadeFaturaBilgi: {
            IadeNedeni: null,
            IstinadenFaturaSeri: null,
            IstinadenFaturaNo: null,
            IstinadenFaturaTarihi: null
          }
        },
        SerbestFaturaDetayList: [],

        SerbestFaturaDetay: {
          MuhasebeKodu: '',
          Aciklama: '',
          LineNote: '',
          Referans: {
            Kod: ''
          },
          Masraf: {
            Code: ''
          },
          Miktar: 0,
          Birim: '',
          BirimFiyat: 0,
          Tutar: 0,
          DovizTutar: 0,
          IskontoYuzde: 0,
          IskontoTutar: 0,
          KdvTip: 'D',
          KdvYuzde: 0,
          KdvTutar: 0,
          KdvMuhKodu: '',
          IskMuhKodu: '',
          KdvKodu: '',
          IstisnaKodu: '',
          TevkifatKodu: '',
          Tip: '',
          TevkifatDetayTutar: 0,
          TevkifatDetayOran: 0,
          EkVergiTutar:0,
          EkVergiYuzde:0,

          TeslimBilgileri: {
            SokakAdi: '',
            BinaAdi: '',
            BinaNo: '',
            TeslimSehir: '',
            TeslimPostaKodu: '',
            TeslimUlke: '',
            TeslimSarti: '',
            GTIPNo: '',
            TransferKodu: '',
            KabinNo: '',
            KabinAdedi: '',
            KabinCinsi: '',
            TeslimOdeme: ''
          }

        },

        SerbestFaturaToplamTutarBilgileri: {
          ToplamTutar: 0,
          Iskonto: 0,
          FaturaToplam: 0,
          Kdv: 0,
          TevkifatKdv: 0
        },

        birim: [{
            text: 'adet',
            value: 'adet'
          },
          {
            text: 'kilo',
            value: 'kilo'
          }, {
            text: this.$t('gram'),
            value: 'gram'
          }, {
            text: this.$t('meter'),
            value: 'metre'
          },
          {
              text: 'litre',
              value: 'litre'
          },
          {
              text: 'm2',
              value: 'm2'
          },
          {
              text: 'dm2',
              value: 'dm2'
          },
          {
              text: 'm3',
              value: 'm3'
          },
        ],


        faturatipi: [{
            text: this.$t('Purchase-Expense'),
            value: 0
          },
          {
            text: this.$t('Sales-Return'),
            value: 1
          },
          {
            text: this.$t('Advance'),
            value: 2
          },
          {
            text: this.$t('Self-employed-Receipt'),
            value: 3
          },
          {
            text: this.$t('Note-of-Expenses'),
            value: 4
          },
          {
            text: this.$t('Withholding-Donation-Receipt'),
            value: 5
          }
        ],
        gonderimsekli: [{
            text: this.$t('Paper'),
            value: 0
          },
          {
            text: this.$t('Electronic'),
            value: 1
          }
        ],

        odemesekli: [{
            text: this.$t('Normal-Sales'),
            value: 0
          },
          {
            text: this.$t('Internet-Sales'),
            value: 1
          }
        ],
        seridisable: true,
        faturagosterbtn: false,

        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',

        datearsiv: null,
        menuarsiv: false,
        modalarsiv: false,
        dateFormattedarsiv: '',
        yedeksatirkayit: {
          Tutar: 0,
          Kdv: 0,
          Tevkifat: 0,
          iskonto: 0
        },
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        ihracat: false,
        satirdialog: false,
        gibseri: [],
        satiritems: [],
        referaslist: [],
        EvrakTipi1: [],
        kdvtipi: [{
            text: 'D',
            value: 'D'
          },
          {
            text: 'H',
            value: 'H'
          }
        ],
        Tevkifat: [{
            text: '0/10',
            value: 0
          },
          {
            text: '1/10',
            value: 0.1
          },
          {
            text: '2/10',
            value: 0.2
          },
          {
            text: '3/10',
            value: 0.3
          },
          {
            text: '4/10',
            value: 0.4
          },
          {
            text: '5/10',
            value: 0.5
          },
          {
            text: '6/10',
            value: 0.6
          },
          {
            text: '7/10',
            value: 0.7
          },
          {
            text: '8/10',
            value: 0.8
          },
          {
            text: '9/10',
            value: 0.9
          },
          {
            text: '10/10',
            value: 1
          }
        ],

        odemesekli1: [{
            text: this.$t('Credit-Debit-Card'),
            value: '0'
          },
          {
            text: 'EFT-' + this.$t('Transfer-v3'),
            value: '1'
          },
          {
            text: this.$t('Cash-on-delivery'),
            value: '2'
          },
          {
            text: this.$t('Payment-Intermediary'),
            value: '3'
          },
          {
            text: this.$t('Other'),
            value: '4'
          }
        ],

        transferkodu: [{
            text: this.$t('Seaways'),
            value: '1'
          },
          {
            text: this.$t('Railway'),
            value: '2'
          },
          {
            text: this.$t('Highway'),
            value: '3'
          },
          {
            text: this.$t('Airline'),
            value: '4'
          },
          {
            text: this.$t('Post'),
            value: '5'
          },
          {
            text: this.$t('Multiple-Vehicles'),
            value: '6'
          },
          {
            text: this.$t('Fixed-Transportation-Complexes'),
            value: '7'
          },
          {
            text: this.$t('Territorial-Water-Transportation'),
            value: '8'
          }
        ],

        teslimodeme: [{
            text: 'Instrument not defined',
            value: 1
          },
          {
            text: 'Automated clearing house credit',
            value: 2
          },
          {
            text: 'Automated clearing house debit',
            value: 3
          },
          {
            text: 'ACH demand debit reversal',
            value: 4
          },
          {
            text: 'ACH demand credit reversal',
            value: 5
          },
          {
            text: 'ACH demand credit',
            value: 6
          },
          {
            text: 'ACH demand debit',
            value: 7
          },
          {
            text: 'Hold',
            value: 8
          },
          {
            text: 'National or regional clearing',
            value: 9
          },
          {
            text: 'In cash',
            value: 10
          },
          {
            text: 'ACH savings credit reversal',
            value: 11
          },
          {
            text: 'ACH savings debit reversal',
            value: 12
          },
          {
            text: 'ACH savings credit',
            value: 13
          },
          {
            text: 'ACH savings debit',
            value: 14
          },
          {
            text: 'Bookentry credit',
            value: 15
          },
          {
            text: 'Bookentry debit',
            value: 16
          },
          {
            text: 'ACH demand cash concentration/disbursement (CCD) credit',
            value: 17
          },
          {
            text: 'ACH demand cash concentration/disbursement (CCD) debit',
            value: 18
          },
          {
            text: 'ACH demand corporate trade payment (CTP) credit',
            value: 19
          },
          {
            text: 'Cheque',
            value: 20
          },
          {
            text: 'Bankers draft',
            value: 21
          },
          {
            text: 'Certified bankers draft',
            value: 22
          },
          {
            text: 'Bank cheque (issued by a banking or similar establishment)',
            value: 23
          },
          {
            text: 'Certified cheque',
            value: 25
          },
          {
            text: 'Local cheque',
            value: 26
          },
          {
            text: 'ACH demand corporate trade payment (CTP) debit',
            value: 27
          },
          {
            text: 'ACH demand corporate trade exchange (CTX) credit',
            value: 28
          },
          {
            text: 'ACH demand corporate trade exchange (CTX) debit',
            value: 29
          },
          {
            text: 'Credit transfer',
            value: 30
          },
          {
            text: 'Debit transfer',
            value: 31
          },
          {
            text: 'ACH demand cash concentration/disbursement plus (CCD+)',
            value: 32
          },
          {
            text: 'ACH demand cash concentration/disbursement plus (CCD+)',
            value: 33
          },
          {
            text: 'ACH prearranged payment and deposit (PPD)',
            value: 34
          },
          {
            text: ' ACH savings cash concentration/disbursement (CCD) credit',
            value: 35
          },
          {
            text: 'ACH savings cash concentration/disbursement (CCD) debit',
            value: 36
          },
          {
            text: 'ACH savings corporate trade payment (CTP) credit',
            value: 37
          },
          {
            text: 'ACH savings corporate trade payment (CTP) debit',
            value: 38
          },
          {
            text: 'ACH savings corporate trade exchange (CTX) credit',
            value: 39
          },
          {
            text: 'ACH savings corporate trade exchange (CTX) debit',
            value: 40
          },
          {
            text: 'ACH savings cash concentration/disbursement plus (CCD+)',
            value: 41
          },
          {
            text: 'Payment to bank account',
            value: 42
          },
          {
            text: 'ACH savings cash concentration/disbursement plus (CCD+)',
            value: 43
          },
          {
            text: 'Accepted bill of exchange',
            value: 44
          },
          {
            text: 'Referenced home-banking credit transfer',
            value: 45
          },
          {
            text: 'Interbank debit transfer',
            value: 46
          },
          {
            text: 'Home-banking debit transfer',
            value: 47
          },
          {
            text: 'Bank card',
            value: 48
          },
          {
            text: 'Direct debit',
            value: 49
          },
          {
            text: 'Payment by postgiro',
            value: 50
          },
          {
            text: 'Promissory note',
            value: 60
          },
          {
            text: '61    Promissory note signed by the debtor',
            value: 61
          },
          {
            text: 'Promissory note signed by the debtor and endorsed by a bank',
            value: 62
          },
          {
            text: 'Promissory note signed by the debtor and endorsed by a',
            value: 63
          },
          {
            text: ' Promissory note signed by a bank',
            value: 64
          },
          {
            text: 'Promissory note signed by a bank and endorsed by another',
            value: 65
          },
          {
            text: 'Promissory note signed by a third party',
            value: 66
          },
          {
            text: 'Promissory note signed by a third party and endorsed by a',
            value: 67
          },
          {
            text: 'Bill drawn by the creditor on the debtor',
            value: 70
          },
          {
            text: 'Bill drawn by the creditor on a bank',
            value: 74
          },
          {
            text: 'Bill drawn by the creditor, endorsed by another bank',
            value: 75
          },
          {
            text: 'Bill drawn by the creditor on a bank and endorsed by a',
            value: 76
          },
          {
            text: 'Bill drawn by the creditor on a third party',
            value: 77
          },
          {
            text: 'Bill drawn by creditor on third party, accepted and',
            value: 78
          },
          {
            text: 'Not transferable banker s draft',
            value: 91
          },
          {
            text: 'Not transferable local cheque',
            value: 92
          },
          {
            text: 'Reference giro',
            value: 93
          },
          {
            text: 'Urgent giro',
            value: 94
          },
          {
            text: 'Free format giro',
            value: 95
          },
          {
            text: 'Requested method for payment was not used',
            value: 96
          },
          {
            text: 'Clearing between partners',
            value: 97
          }

        ],
        islembilgileri: [{
            text: this.$t('Hard-Copy-Invoice'),
            value: 'false'
          },
          {
            text: this.$t('Electronic-Invoice'),
            value: 'true'
          }
        ],

        doviztipi: [],
        webadresleri: [],
        odemesekilleri: [],
        odemearaci: [],
        dizayn: null,

        ichattipi: [
          'D', 'D-', 'D+', 'K', 'K-', 'K+', 'U', 'U-', 'U+', 'L', 'L-', 'L+'
        ],

        evethayir: [{
            text: this.$t('Yes'),
            value: 'E'
          },
          {
            text: 'Hayır',
            value: 'H'
          },
        ],

        cmkodu: [
          'C', 'M'
        ],
        dizaynsec: [],
        xsltitems: [],
        masrafmerkezi: [],
        dictionary: {
          custom: {
            carikod: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            unvan: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            faturaseri: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            faturano: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },

            dizayn: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            xslt: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            gtip: {
              min: () => this.$t('Must-least-4-digits'),
            }

          }
        },
        sayfabaslik: 'Coper Gelen Fatura',
        satirguncellebuton: false,
        satirkaydetbuton: true,
        StartDate: null,
        EndDate: null,
        NumberOfPolicies: '',
        PolicySum: '',
        TotalDebt: '',
        TotalFlatDebt: '',
        kaydetbuton: true,
        guncellebuton: false,
        silbuton: false,
        detaytevkifat: true,
        text1: '',
        denemevalue: 0,

        biletlerfaturalanmasin: null,
        efaturamukellefi: null,
        loadingdialog: false,
        Kdvmuaf: null,
        ciktiistemiyor: null,
        musteribilgitipi: null,
        profilzorunlu: null,
        eventidzorunlu: null,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        carikod: '',
        unvan: '',
        active: '',
        ex11: 'false',
        dialogearsiv: false,
        earsivdurum: false,
        guidim: null,
        idim: null,
        kredilimiti: 0,
        dizaynIdget: null,
        xsltIdget: null,
        faturasilbtn: false,
        satirsilbtn: false,
        islemturu: null,
        ChangeTarih: null,
        ChangeFaturaNo: null,

      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      // this.deneme();




      //this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
      this.sayfayetki.Status = true
      this.sayfayetki.Save = true
      this.sayfayetki.Update = true
      this.sayfayetki.Delete = true

      if (this.sayfayetki.Status == true) {

        this.SerbestFaturaDetayList = []

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params1 = {
          CompanyCode: credentials.SirketKodu,
        }


        this.$http.post(auth.API_URL + 'api/currency/List', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.doviztipi = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Döviz Tipi'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Döviz Tipi'
            this.snackbar = true
          }
        })



        if (this.$route.query.islem == "yeni" || this.$route.query.islem == "get") {
          this.sayfabaslik = 'Coper İade Faturası'
          this.guncellebuton = false
          this.kaydetbuton = true
          this.islemtipi = 1


          this.loadingdialog = true

          let params = {
            SaticiTip: this.$route.query.st,
            SaticiKod: this.$route.query.sk,
            FatSeri: this.$route.query.fs,
            FatNo: this.$route.query.fn,
            FatTarih: this.$route.query.ft
          }

          tool.http_post(this, 'GelenFaturaLoad', params).then(

            response => {

              if (response.body.Status == true) {


                this.GelenFatura.Fatura = response.body.data

                this.IadeFatura.Fatura.IadeFaturaBilgisi.GelenFaturaNo = response.body.data.FatNo
                this.IadeFatura.Fatura.IadeFaturaBilgisi.GelenFaturaSaticiTip = response.body.data.SaticiTip
                this.IadeFatura.Fatura.IadeFaturaBilgisi.GelenFaturaSaticiKod = response.body.data.SaticiKod
                this.IadeFatura.Fatura.IadeFaturaBilgisi.GelenFaturaSeri = response.body.data.FatSeri
                this.IadeFatura.Fatura.IadeFaturaBilgisi.GelenFaturaTarihi = response.body.data.FatTarih
                this.pnr = response.body.data.Kalemler[0].PNR_No
                this.sablonGetir();

              } else {
                this.text1 = response.body.ErrorList[0]
                this.snackbar = true
              }
              this.loadingdialog = false

            },

            response => {

              this.text1 = 'Hata Oluştu, tekrar deneyiniz'
              this.loadingdialog = false
              this.snackbar = true

            }

          );


        } else {
          this.snackbar = true
          this.text1 = 'Hatalı url'
        }

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          }

        });

      }
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      },

      orangoster: function (m) {
        return m * 100;
      }
    },
    methods: {
      controlDigit(val){
        var price = val.toString().split(".").map(Number);

        if(price[1] != null && price[1].toString().length > 3){
          return  price[0] + '.' + price[1].toString().substring(0,2);
        }else{
          return val;
        }
      },
      HataYonetimi(response, request, baslik) {
        if (response.status === 500) //Internal Server Error
        {
          this.$refs.hatadialog.open(response, request, baslik);
        } else {
          this.text1 = 'Service Unavailable -' + baslik;
          this.snackbar = true;
        }
      },
      IadeFaturasiTaslakOnayla() {
        let params = {
          TaslakIdList: this.taslakIdItems
        }

        tool.http_post(this, "IadeFaturasiTaslakOnayla", params).then(
          response => {
            this.loading = false;
            if (response.body.Status == true) {
              this.text1 = 'Taslak Faturalandı.'
              this.snackbar = true
            } else {
              this.text1 = response.body.ErrorList[0]
              this.snackbar = true
            }
          },
          response => {
            this.HataYonetimi(response, params, this.$t('Template-not-approved'));
          }
        );
      },
      FaturaTaslakUpdate() {

        let params = {
          FaturaTaslak: this.faturaitems
        }
        this.loading = true;
        tool.http_post(this, "FaturaTaslakUpdate", params).then(
          response => {

            if (response.body.Status == true) {

              this.IadeFaturasiTaslakOnayla();

            } else {

              this.text1 = response.body.ErrorList[0]
              this.snackbar = true
              this.faturagoster = false
              this.loading = false;
            }
          },
          response => {

            this.HataYonetimi(response, params, this.$t('Template-not-saved'));
            this.faturagoster = false

          }
        );
      },
     
      seriEnter(v) {
        var indexno = this.itemsfaturaseri.indexOf(document.getElementById('serientervalue').value)
        if (indexno == -1) {
          this.itemsfaturaseri.push(document.getElementById('serientervalue').value)
          this.yenibaslikBilgi.FaturaSeri = document.getElementById('serientervalue').value
        }
      },
      sablonGetir() {
        let params = {
          FaturaKesimOzellik: {
            Tip: this.IadeFatura.FaturaKesimOzellik.Tip,
            FaturaTur: this.IadeFatura.FaturaKesimOzellik.FaturaTur,
            FaturaTip: this.IadeFatura.FaturaKesimOzellik.FaturaTip,
            KesimTip: 3
          }
        }

        tool.http_post(this, 'FaturaSablonList', params).then(
          response => {
            if (response.body.Status == true) {
              this.itemsFaturaSablon = response.body.data
              this.faturaSablon = response.body.data[0]
            } else {
              this.text1 = response.body.ErrorList[0]
              this.snackbar = true
            }
          },

          response => {
            this.HataYonetimi(response, params, this.$t('Template-List-not-Found'));
          }

        );
      },
      yeniSablonEkle() {
        this.yeniSablonDialog = true
      },
      yeniSablonKaydet() {
        if (this.$refs.formyenisablon.validate()) {
          this.loadingdialog = true
          let params = {
            FaturaKesimOzellik: this.IadeFatura.FaturaKesimOzellik,
            SablonAdi: this.yeniSablonAdi,
            DipAciklamaSablonu: null, // this.dizaynData.DipAciklamaSablonu,
            KalemAciklamaSablonu: [], // this.dizaynData.KalemAciklamaSablonu,
            ReportBroId: null, // this.dizaynData.ReportBroId,
            XsltId: null, // this.dizaynData.XsltId
          }

          tool.http_post(this, 'FaturaSablonSave', params).then(
            response => {
              if (response.body.Status == true) {
                this.dizaynData = response.body.data
                this.dizaynView = false
                this.faturagoster = false

                if (response.body.Status == true) {
                  this.sablonGetir();
                  this.text1 = "Kayıt edildi."
                  this.snackbar = true
                  this.yeniSablonDialog = false
                } else {
                  this.text1 = response.body.ErrorList[0]
                  this.snackbar = true
                }
                this.loadingdialog = false



                response => {
                  this.HataYonetimi(response, params, 'Fatura Sablon Listesi getirilemedi');

                }



              } else {
                this.text1 = response.body.ErrorList[0]
                this.snackbar = true
                this.dizaynView = true

              }
              this.loadingdialog = false

            },

            response => {

              this.HataYonetimi(response, params, this.$t('Invoice-not-Saved-Template'));

              this.dizaynView = true
              this.loadingdialog = false
            }

          );

        }

      },
      faturaSablonDuzenle() {
        if (this.$refs.formfatura.validate()) {
          this.loadingdialog = true
          this.Dizayn.SaticiTip = 1
          this.dizaynViewType = 1

          let params = {
            FaturaKesimOzellik: this.IadeFatura.FaturaKesimOzellik,
            SablonAdi: this.faturaSablon
          }

          tool.http_post(this, 'FaturaSablonLoad', params).then(
            response => {
              if (response.body.Status == true) {
                this.dizaynData = response.body.data
                this.dizaynView = true
                this.getSaticiDizayn(1);
                var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                let paramsxslt = {
                  CompanyCode: credentials.SirketKodu
                }
                this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableList', paramsxslt, {
                  headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                  }
                }).then((response) => {
                  this.xsltitems = response.body
                }, (response) => {
                  if (response.status === 0) {
                    this.progress = false
                    this.text1 = 'Service Unavailable-InvoiceXsltTableList'
                    this.snackbar = true
                  } else {
                    this.HataYonetimi(response, paramsxslt, 'InvoiceXsltTableList işelemi başarısız');
                  }
                })

              } else {
                this.text1 = response.body.ErrorList[0]
                this.snackbar = true
                this.dizaynView = false

              }
              this.loadingdialog = false

            },

            response => {
              this.HataYonetimi(response, params, 'Fatura Şablon Getirilemedi');
              this.dizaynView = false
              this.loadingdialog = false
            }

          );

        } else {
          this.text1 = this.$t('Select-Template')
          this.snackbar = true
        }

      },
      onMove({
        relatedContext,
        draggedContext
      }) {
        const relatedElement = relatedContext.element;
        const draggedElement = draggedContext.element;
        return ((!relatedElement || !relatedElement.fixed) && !draggedElement.fixed);

      },
      getSaticiDizayn(val) {
        var index = this.dizaynData.KalemAciklamaSablonu.map(function (e) {
          return e.SaticiTip;
        }).indexOf(val);

        if (index != -1) {
          this.kayitvarmi = index
        }
      },
      ItemAktar(val) {
        var cursorPos = document.getElementById('textalan').selectionStart
        var textBefore = this.dizaynData.KalemAciklamaSablonu[this.kayitvarmi].AciklamaSablonu.substring(0, cursorPos);
        var textAfter = this.dizaynData.KalemAciklamaSablonu[this.kayitvarmi].AciklamaSablonu.substring(cursorPos, this
          .dizaynData.KalemAciklamaSablonu[this.kayitvarmi].AciklamaSablonu.length);
        this.dizaynData.KalemAciklamaSablonu[this.kayitvarmi].AciklamaSablonu = textBefore + val + textAfter;
      },
      ItemAktarDip(val) {

        if (this.dizaynData.DipAciklamaSablonu == null) {
          this.dizaynData.DipAciklamaSablonu = ''
        }
        var cursorPos = document.getElementById('textalanDip').selectionStart
        var textBefore = this.dizaynData.DipAciklamaSablonu.substring(0, cursorPos);
        var textAfter = this.dizaynData.DipAciklamaSablonu.substring(cursorPos, this.dizaynData.DipAciklamaSablonu
          .length);
        this.dizaynData.DipAciklamaSablonu = textBefore + val + textAfter;
      },
      iptal() {
        this.dizaynView = false
        this.kayitvarmi = -1
      },
      kalemDizaynKaydet() {
        if (this.$refs.formsaticidizayn.validate()) {
          this.loadingdialog = true
          let params = {
            FaturaKesimOzellik: this.IadeFatura.FaturaKesimOzellik,
            SablonAdi: this.faturaSablon,
            DipAciklamaSablonu: this.dizaynData.DipAciklamaSablonu,
            KalemAciklamaSablonu: this.dizaynData.KalemAciklamaSablonu,
            ReportBroId: this.dizaynData.ReportBroId,
            XsltId: this.dizaynData.XsltId
          }

          tool.http_post(this, 'FaturaSablonSave', params).then(
            response => {
              if (response.body.Status == true) {
                this.dizaynData = response.body.data
                this.dizaynView = false
                this.faturagoster = false

                this.sablonGetir();

              } else {
                this.text1 = response.body.ErrorList[0]
                this.snackbar = true
                this.dizaynView = true

              }
              this.loadingdialog = false

            },

            response => {

              this.HataYonetimi(response, params, this.$t('Invoice-not-Saved-Template'));

              this.dizaynView = true
              this.loadingdialog = false
            }

          );

        } else {
          this.text1 = this.$t('Select-Template')
          this.snackbar = true
        }

      },
      faturaSablonDipDuzenle() {
        if (this.$refs.formfatura.validate()) {
          this.loadingdialog = true

          this.dizaynViewType = 2

          let params = {
            FaturaKesimOzellik: this.IadeFatura.FaturaKesimOzellik,
            SablonAdi: this.faturaSablon
          }

          tool.http_post(this, 'FaturaSablonLoad', params).then(
            response => {
              if (response.body.Status == true) {
                this.dizaynData = response.body.data
                this.dizaynView = true

              } else {
                this.text1 = response.body.ErrorList[0]
                this.snackbar = true
                this.dizaynView = false

              }
              this.loadingdialog = false

            },

            response => {
              this.HataYonetimi(response, params, 'Fatura Şablon Getirilemedi');
              this.dizaynView = false
              this.loadingdialog = false

            }

          );

        } else {
          this.text1 = this.$t('Select-Template')
          this.snackbar = true
        }

      },
      faturaSablonSil() {
        if (this.$refs.formfatura.validate()) {

          this.$refs.onaydialog.open("this.$t('Are-you-sure-you-want-to-delete-this-record')", 1).then(sonuc => {

            if (sonuc == true) {
              let params = {
                FaturaKesimOzellik: this.IadeFatura.FaturaKesimOzellik,
                SablonAdi: this.faturaSablon
              }

              tool.http_post(this, "FaturaSablonDelete", params).then(
                response => {

                  if (response.body.Status == true) {
                    this.text1 = 'Fatura Şablonu silindi.'
                    this.snackbar = true

                    this.sablonGetir();
                  } else {

                    this.text1 = response.body.ErrorList[0]
                    this.snackbar = true
                  }
                },
                response => {
                  this.HataYonetimi(response, params, 'Fatura Şablonu Silinemedi');
                }
              );

            }
          });

        } else {
          this.text1 = this.$t('Select-Template')
          this.snackbar = true
        }
      },
      faturaTaslakSil() {
        this.$refs.onaydialog.open('Bu kayıtı silmek istediğinize eminmisiniz', 1).then(sonuc => {

          if (sonuc == true) {

            let params = {
              PNR_No: this.pnr
            }

            tool.http_post(this, "PNRFaturaTaslagiSil", params).then(
              response => {

                if (response.body.Status == true) {
                  this.text1 = 'Taslak silindi.'
                  this.snackbar = true

                } else {

                  this.text1 = response.body.ErrorList[0]
                  this.snackbar = true
                }
              },
              response => {
                this.HataYonetimi(response, params, 'Fatura Taslağı Silinemedi');
              }
            );

          }
        });

      },
      iadeFaturaYazdir(val) {

        if (this.IadeFatura.Fatura.Kalemler.length > 0) {

          this.loadingdialog = true

          this.IadeFatura.Sablon = this.faturaSablon

          this.IadeFatura.Fatura.ToplamTutar = 0
          this.IadeFatura.Fatura.ToplamKDVliTutar = 0
          this.IadeFatura.Fatura.ToplamKDVTutar = 0
          this.IadeFatura.Fatura.ToplamTevkifatTutar = 0
          this.IadeFatura.Fatura.FaturaNetTutar = 0
          this.IadeFatura.Fatura.ToplamEkVergiTutar = 0


          this.IadeFatura.Fatura.Kalemler.forEach(element => {

            
            


            this.IadeFatura.Fatura.ToplamTutar +=  element.Tutar
            this.IadeFatura.Fatura.ToplamKDVliTutar +=  element.Tutar + element.KDVTutar
            this.IadeFatura.Fatura.ToplamKDVTutar +=  element.KDVTutar
            this.IadeFatura.Fatura.ToplamEkVergiTutar +=  element.EkVergiTutar
            
            this.IadeFatura.Fatura.ToplamTevkifatTutar += element.TevkifatTutar
            this.IadeFatura.Fatura.FaturaNetTutar += element.Tutar + element.KDVTutar - element.TevkifatTutar + element.EkVergiTutar;

          });

            //this.IadeFatura.Fatura.ToplamKDVTutar = this.controlDigit(this.IadeFatura.Fatura.ToplamKDVTutar);
            //this.IadeFatura.Fatura.ToplamKDVliTutar = this.controlDigit(this.IadeFatura.Fatura.ToplamKDVliTutar);

            // this.IadeFatura.Fatura.ToplamTutar = this.moneyformat(this.IadeFatura.Fatura.ToplamTutar);
            // this.IadeFatura.Fatura.ToplamKDVliTutar = this.moneyformat(this.IadeFatura.Fatura.ToplamKDVliTutar);
            // this.IadeFatura.Fatura.ToplamKDVTutar = this.moneyformat(this.IadeFatura.Fatura.ToplamKDVTutar);
            // this.IadeFatura.Fatura.ToplamTevkifatTutar = this.moneyformat(this.IadeFatura.Fatura.ToplamTevkifatTutar);
            // this.IadeFatura.Fatura.FaturaNetTutar = this.moneyformat(this.IadeFatura.Fatura.FaturaNetTutar);



          let params = this.IadeFatura

       

          tool.http_post(this, "IadeFaturasiHazirla", params).then(
            response => {
              this.loadingdialog = false


              if (response.body.Status == true) {
                this.taslakIdItems = response.body.data.TaslakIdList
                this.faturaitems = response.body.data.IlkFatura
                this.Aciklamalar = response.body.data.Aciklamalar

                this.faturagoster = true
              } else {

                this.text1 = response.body.ErrorList[0]
                this.snackbar = true
                this.faturagoster = false
              }
            },
            response => {

              this.HataYonetimi(response, params, this.$t('Invoice-not-prepared'));
              this.loadingdialog = false
              this.faturagoster = false

            }
          );

        } else {
          this.text1 = this.$t('Please-add-item-the-list')
          this.snackbar = true
        }



      },
      satirsilsor(item) {
        this.dialogsor = true;
        this.faturasilbtn = false;
        this.satirsilbtn = true,
          this.silinecekkayit = item
      },
      faturasilsor() {
        this.dialogsor = true;
        this.faturasilbtn = true;
        this.satirsilbtn = false
      },
      satirsil(a) {

        this.$refs.onaydialog.open("this.$t('Are-you-sure-you-want-to-delete-this-record')", 1).then(
          sonuc => {

            if (sonuc == true) {
              const index = this.IadeFatura.Fatura.Kalemler.indexOf(a)

              if (index != -1) {

                this.IadeFatura.Fatura.Kalemler.splice(index, 1)
                this.dialogsor = false;
                //     this.diptopla();

              }
            }
          });



      },
      satirduzenle(a) {

        var kayitIndex = this.itemskalemler.map(function (e) {
          return e.IslemRef;
        }).indexOf(a.IslemRef);
        this.secilenKalem = this.itemskalemler[kayitIndex]


        this.kalemData.Tutar = a.Tutar
        this.kalemData.KDVYuzde = a.KDVYuzde
        this.kalemData.EkVergiYuzde = a.EkVergiYuzde
        


        this.kdvkodu = a.KdvID
        this.istisnakodu = a.KdvMuafiyetID
        this.tevkifatkodu = a.TevkifatID

        this.duzenlenenkayitindex = this.IadeFatura.Fatura.Kalemler.indexOf(a);
        this.satirdialog = true
        this.satirbuton = false
      },
      satirguncellekaydet() {

        this.kalemData.KDVTutar = this.roundNumber((this.kalemData.Tutar / 100) * this.kalemData.KDVYuzde,2)
        this.kalemData.EkVergiTutar = this.roundNumber((this.kalemData.Tutar / 100) * this.kalemData.EkVergiYuzde,2)
        this.kalemData.KDVliTutar = this.kalemData.Tutar + this.kalemData.KDVTutar
        this.kalemData.PNR_No = this.secilenKalem.PNR_No
        this.kalemData.IslemRef = this.secilenKalem.IslemRef
        this.kalemData.TevkifatOran = this.tevkifatkodu.intField / 10
        this.kalemData.TevkifatTutar = this.roundNumber((this.kalemData.KDVTutar * this.kalemData.TevkifatOran),2)
        this.kalemData.KdvID = this.kdvkodu
        this.kalemData.KdvMuafiyetID = this.istisnakodu
        this.kalemData.TevkifatID = this.tevkifatkodu
       
        


        var yenikayit = {
          Tutar: this.kalemData.Tutar,
          KDVTutar: this.roundNumber((this.kalemData.Tutar / 100) * this.kalemData.KDVYuzde,2),
          EkVergiTutar: this.roundNumber((this.kalemData.Tutar / 100) * this.kalemData.EkVergiYuzde,2),
          
          KDVliTutar: this.kalemData.Tutar + this.kalemData.KDVTutar,
          PNR_No: this.secilenKalem.PNR_No,
          IslemRef: this.secilenKalem.IslemRef,
          TevkifatOran: this.tevkifatkodu.intField / 10,
          TevkifatTutar: this.roundNumber(this.kalemData.KDVTutar * this.kalemData.TevkifatOran,2),
          KdvID: this.kdvkodu,
          KdvMuafiyetID: this.istisnakodu,
          TevkifatID: this.tevkifatkodu,
          KDVYuzde: this.kalemData.KDVYuzde,
          EkVergiYuzde: this.kalemData.EkVergiYuzde
          

        }


        this.IadeFatura.Fatura.Kalemler.splice(this.duzenlenenkayitindex, 1, yenikayit)
        this.satirdialog = false
        this.diptopla();
      },
      getdatetimenow() {

        var timenow = helpers.getTimeNow();

        return String(timenow)
      },
      denemeyazdir(divName) {

        var mywindow = window.open('', 'PRINT', 'height=500,width=700');

        mywindow.document.write('</head>');
        mywindow.document.write('<style>');
        //yazdırılmayacak alanlar için css ekliyorum
        mywindow.document.write('@media print{.no-print {display:none !important;}}');
        mywindow.document.write('</style>');
        mywindow.document.write('<body >');
        mywindow.document.write(document.getElementById(divName).innerHTML);
        mywindow.document.write('</body></html>');

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        mywindow.close();

        return true;

      },
      EditSatirAciklama(val) {
        this.editedItem = val;
        this.SatirDialog = true;

      },
      EditSatirAciklama2(val) {
        this.editedItem2 = val;
        this.SatirDialog2 = true;
      },
      baslikGuncelle() {
        this.$refs.faturaheaderdialog.open(this.faturaitems,this.FaturaKesimOzellik);
      },

     

   
      tutarblur() {
        this.SatirGelenFatura.KDVTutar = (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura.KDVYuzde
        this.SatirGelenFatura.TevkifatTutar = this.SatirGelenFatura.KDVTutar * this.SatirGelenFatura.TevkifatOran
        this.SatirGelenFatura.StopajTutar = (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura.StopajOran
        this.SatirGelenFatura.EkVergiTutar = (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura.EkVergiYuzde
        

      },
      kdvtutarblur() {

      },
      test2(v) {
        // this.secilenkayitlar = []
        // this.itemsgelen = []

        if (String(v).length > 3 && v != null) {
          // this.kalemGetir();
        }

      },

      sontutarkontrol(toplamdeger, toplam, deger) {
        toplam = this.roundNumber(toplam, 2)
        if (toplamdeger < toplam) {
          var fark = toplam - toplamdeger
          let kdvtut = deger + fark
          return kdvtut
        } else if (toplamdeger > toplam) {
          var sonek = this.roundNumber(toplamdeger - deger, 2);
          var eklenecek = toplam - sonek
          let kdvtut = eklenecek // - fark
          return kdvtut
        } else {
          return deger
        }

      },

      deneme() {
        var a = this.twodigitcalc(1, 10)
      },
      twodigitcalc(bolunen, bolen) {
        var dizi = []
        var a = parseFloat(bolunen)
        var b = parseFloat(bolen)

        if (a >= b) {
          var kactane = Math.floor(a / b)
          var ters = Math.floor(a / kactane)
        } else {
          var kactane = Math.floor(b / a)
          var ters = Math.floor(kactane / 1)
        }
        if (bolen != 0 && bolunen != 0) {
          var bolum = this.roundNumber(a / b, 2)
          var top = 0
          var kalani = 0
          for (var x = 0; x < b; x++) {
            kalani = a - top
            if (x + 1 != b) {
              dizi.push(bolum)
            } else {

              dizi.push(this.roundNumber(kalani, 2))
            }

            top = top + bolum
          }
          return dizi;
        } else {

          for (var x = 0; x < bolen; x++) {
            dizi.push(0)
          }
          return dizi;

        }
      },
      git(val) {
        var url = "#/fatura/copergelenfatura/id?islem=get&st=" + val.SaticiTip + '&sk=' + val.SaticiKod + '&fs=' + val
          .FatSeri + '&fn=' + val.FatNo + '&ft=' + val.FatTarih
        window.open(url, "_self");
      },
      kalemguncellekaydet() {

        this.Kalem.KDVliTutar = this.Kalem.Tutar + this.Kalem.KDVTutar

        var indexno = this.duzenlenenkayitindex
        var kayit = {
          KDVYuzde: this.Kalem.KDVYuzde,
          Tutar: this.roundNumber(this.Kalem.Tutar, 2),
          KDVliTutar: this.roundNumber(this.Kalem.KDVliTutar, 2),
          KDVTutar: this.roundNumber(this.Kalem.KDVTutar, 2),
          EkVergiTutar: this.roundNumber(this.Kalem.EkVergiTutar, 2),
          EkVergiYuzde: this.roundNumber(this.Kalem.EkVergiYuzde, 2),
          
          PNR_No: Number(this.Kalem.PNR_No),
          TevkifatOran: this.Kalem.TevkifatOran,
          TevkifatTutar: this.roundNumber(this.Kalem.TevkifatTutar, 2),
          StopajOran: this.Kalem.StopajOran,
          StopajTutar: this.roundNumber(this.Kalem.StopajTutar, 2),
          IslemRef: this.Kalem.IslemRef
        }


        this.GelenFatura.Fatura.Kalemler.splice(indexno, 1, kayit)
        this.kalemdialog = false
        this.diptopla();

      },
      diptopla() {
        this.GelenFatura.Fatura.ToplamTutar = 0
        this.GelenFatura.Fatura.ToplamKDVliTutar = 0
        this.GelenFatura.Fatura.ToplamKDVTutar = 0
        this.GelenFatura.Fatura.ToplamTevkifatTutar = 0
        this.GelenFatura.Fatura.ToplamStopajTutar = 0
        this.GelenFatura.Fatura.FaturaNetTutar = 0
        this.GelenFatura.Fatura.ToplamEkVergiTutar = 0
        
        this.GelenFatura.Fatura.Kalemler.forEach(element => {
          this.GelenFatura.Fatura.ToplamTutar += element.Tutar
          this.GelenFatura.Fatura.ToplamKDVliTutar += element.KDVliTutar
          this.GelenFatura.Fatura.ToplamKDVTutar += element.KDVTutar
          this.GelenFatura.Fatura.ToplamTevkifatTutar += element.TevkifatTutar
          this.GelenFatura.Fatura.ToplamStopajTutar += element.StopajTutar
          this.GelenFatura.Fatura.ToplamEkVergiTutar += element.EkVergiTutar
        

        });

        this.GelenFatura.Fatura.FaturaNetTutar = this.GelenFatura.Fatura.ToplamKDVliTutar - this.GelenFatura.Fatura
          .ToplamTevkifatTutar + this.GelenFatura.Fatura.ToplamEkVergiTutar;
      },

      kalanVarmi(x, y) {
        var sonuc = {
          durum: false,
          bolum: 0,
          kalan: 0
        }

        var c = this.roundNumber(x / y, 2);
        var carpim = c * y
        var kalan = this.roundNumber(100 - carpim, 2)

        if (kalan != 0) {
          sonuc.durum = true
          sonuc.kalan = kalan
          sonuc.bolum = c
        } else {
          sonuc.durum = false
          sonuc.kalan = 0
          sonuc.bolum = c
        }
        return sonuc
      },

      roundNumber(num, scale) {
        if (!("" + num).includes("e")) {
          return +(Math.round(num + "e+" + scale) + "e-" + scale);
        } else {
          var arr = ("" + num).split("e");
          var sig = ""
          if (+arr[1] + scale > 0) {
            sig = "+";
          }
          return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
        }
      },

      kalemGetir() {

        this.secilenkayitlar = []
        this.itemsgelen = []


        let params = {
          Tip: 1,
          Id: this.GelenFatura.Fatura.Kalemler[0].PNR_No,
          ParaBirimi: 'TL'

        }

        tool.http_post(this, 'PNRKalemList', params).then(

          response => {
            if (response.body.Status == true) {
              this.itemskalemler = response.body.data
              if (response.body.data.length > 0) {
                this.secilenKalem = response.body.data[0]
              }
            } else {
              this.text1 = response.body.ErrorList[0]
              this.snackbar = true
            }
          },
          response => {
            this.text1 = 'Hata Oluştu, tekrar deneyiniz'
            this.snackbar = true
          }

        );









      },
      getparabirimi() {
        return helpers.getparabirimi()
      },
    

   

      Yazdir() {
        this.dizaynbilgigetir(this.SerbestFatura.EFaturaShowID.DizaynID);

        if (this.SerbestFatura.EFaturaShowID.PdfID != 0) {
          var prm = {
            id: this.SerbestFatura.EFaturaShowID.EFaturaID,
            guid: this.SerbestFatura.EFaturaShowID.EFaturaGuid
          };

          this.$refs.reportbrosablon.Print(prm, this.SerbestFatura.EFaturaShowID.PdfID).then(
            confirm => {
              if (confirm.sonuc == true) {

              } else {
                this.text1 = confirm.mesaj
                this.snackbar = true
              }
            });
        } else {
          this.text1 = this.$t('design-you-selected-does-include-invoice-present-design-Invoice-screen')
          this.snackbar = true
        }
      },
      xsltgetir() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var paramsxslt = {
          CompanyCode: credentials.SirketKodu,

        }
        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableList', paramsxslt, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.xsltitems = response.body

          this.SerbestFatura.EFaturaShowID.XsltID = this.xsltIdget;

        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          }
        })

      },
      dizaynbilgigetir(Faturaid) {
        this.dizaynsec.forEach(element => {
          if (element.FaturaId == Faturaid) {
            this.SerbestFatura.EFaturaShowID.XsltID = element.FaturaXsltId
            this.SerbestFatura.EFaturaShowID.PdfID = element.FaturaPdfID
          }
        });
      },


      tarihkontrol(v) {

        if (v != "0001-01-01T00:00:00" && v != null) {
          var parts1 = v.split("-");
          return (parts1[2] + '-' + parts1[1] + '-' + parts1[0]);
        } else {
          return null;
        }
      },
      
    
      satirekle: satirekle,
      
      getDateNow: getDateNow,
      getDateNow1: getDateNow1,
      toDateformat: toDateformat,
      
      Kaydet: Kaydet,
      satirkaydet: satirkaydet,
      iskontooranhesapla: iskontooranhesapla,
      
      anatevkifatkdvkontrol: anatevkifatkdvkontrol,
      anatevkifatiptal: anatevkifatiptal,
      kurgetir: kurgetir,
      kurgetir2: kurgetir2,
      faturasil: faturasil,
    },

    beforeMount: beforeMount,
    components: {
      'parainputevents': parainputevents,
      'dovizinput': dovizinput,
      'yuzdeinput': yuzdeinput,
      'tarihcomp': tarihcomp,
      referansmerkezicomp,
      masrafmerkezicomp,
      geneltiplist,
      yetkidialog,
      onaydialog,
      genelarama,
      pnrbul,
      geneltipara,
      muhasebefistipara,
      coperkdvkodu,
      copertevkifatkodu,
      coperistisnakodu,
      reportbrosablon,
      kur,
      webadresicomp,
      odemesekillericomp,
      odemearacicomp,
      draggable,
      hatadialog,
      yetkidialog,
      faturaheaderdialog
    },
    watch: {

      'IadeFatura.FaturaKesimOzellik.Tip': function (val) {
        this.sablonGetir();
      },
      'IadeFatura.FaturaKesimOzellik.FaturaTur': function (val) {
        this.sablonGetir();
      },
      'IadeFatura.FaturaKesimOzellik.FaturaTip': function (val) {
        this.sablonGetir();
      },
      'Dizayn.SaticiTip': function (val) {
        this.getSaticiDizayn(val)
      },
      isDragging(newValue) {
        if (newValue) {
          this.delayedDragging = true;
          return;
        }
        this.$nextTick(() => {
          this.delayedDragging = false;
        });
      },


     
     
      'IadeFatura.Fatura.FatPara': function (dovizkod) {

        if (dovizkod != null && this.islemtipi == 1) {
          //  this.kurgetir();
        }
      },




    }
  }


 

  function kurgetir() {

    var params1 = {
      Tarih: this.GelenFatura.Fatura.FatTarih,
      DovizKod: this.GelenFatura.Fatura.SatisPara
    }


    this.$http.post(auth.API_URL + 'api/Definitions/GetWebRate', params1, {
      headers: auth.getAuthCompaniesInfo()
    }).then((response) => {
         if(response.body == 0.0){
          this.GelenFatura.Fatura.SatisKur = 1
          }else{
          this.GelenFatura.Fatura.SatisKur = response.body
          }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-GetWebRate'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-GetWebRate'
        this.snackbar = true
      }
    })

  }

  function kurgetir2() {

    var params1 = {
      Tarih: this.IadeFatura.Fatura.IadeFaturaBilgisi.GelenFaturaTarihi,
      DovizKod: this.IadeFatura.Fatura.FatPara
    }
 
      this.$http.post(auth.API_URL + 'api/Definitions/GetWebRate', params1, {
      headers: auth.getAuthCompaniesInfo()
    }).then((response) => {
          if(response.body == 0.0){
          this.IadeFatura.Fatura.FatKur = 1
          }else{
          this.IadeFatura.Fatura.FatKur = response.body
          }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-GetWebRate'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-GetWebRate'
        this.snackbar = true
      }
    })

  }



  function anatevkifatkdvkontrol() {
    if (this.SerbestFatura.TevkivatKdv != 0 && this.SerbestFatura.TevkivatKdv != null && this.SerbestFatura
      .TevkivatKdv !=
      '') {
      if (this.SerbestFaturaDetay.TevkifatDetayOran != 0 && this.SerbestFaturaDetay.TevkifatDetayOran != null && this
        .SerbestFaturaDetay
        .TevkifatDetayOran != '') {

        this.text1 = this.$t('Deduction-Rate-Selected-Free-Invoice-Detail-Screen')
        this.snackbar = true
        this.SerbestFatura.TevkivatKdv = null

      } else {

        this.detaytevkifat = false
        this.SerbestFaturaDetay.TevkifatDetayOran = 0
        this.SerbestFaturaDetay.TevkifatDetayTutar = 0
      }


    } else {
      this.detaytevkifat = true
    }
  }

  function anatevkifatiptal() {

    if (this.SerbestFatura.TevkivatKdv === 0 || this.SerbestFatura.TevkivatKdv === null || this.SerbestFatura
      .TevkivatKdv ===
      '') {
      this.detaytevkifat = true
    }
  }

  

  function satirekle() {
    this.kalemGetir();
    this.satirdialog = true
    this.kalemData.KDVYuzde = 0
    this.kalemData.Tutar = 0
    this.kalemData.EkVergiYuzde = 0
    this.kalemData.EkVergiTutar = 0
    
    this.kalemData.KDVliTutar = 0
    this.kalemData.KDVTutar = 0
    this.kalemData.PNR_No = null
    this.kalemData.IslemRef = null
    this.kalemData.TevkifatOran = 0
    this.kalemData.TevkifatTutar = 0
    this.kalemData.KdvID = null
    this.kalemData.KdvMuafiyetID = null
    this.kalemData.TevkifatID = null
    this.itemskalemler = []
    this.secilenKalem.PNR_No = null
    this.satirbuton = true

    this.kdvkodu = {
      id: null,
      intField: null,
      isim: null,
      kod: null,
      tip: null
    }
    this.istisnakodu = {
      id: null,
      intField: null,
      isim: null,
      kod: null,
      tip: null
    }
    this.tevkifatkodu = {
      id: null,
      intField: null,
      isim: null,
      kod: null,
      tip: null
    }
  }

  function satirkaydet() {

    this.kalemData.KDVTutar = this.roundNumber((this.kalemData.Tutar / 100) * this.kalemData.KDVYuzde,2)
    this.kalemData.EkVergiTutar = this.roundNumber((this.kalemData.Tutar / 100) * this.kalemData.EkVergiYuzde,2)
    
    this.kalemData.KDVliTutar = this.kalemData.Tutar + this.kalemData.KDVTutar
    this.kalemData.PNR_No = this.secilenKalem.PNR_No
    this.kalemData.IslemRef = this.secilenKalem.IslemRef
    this.kalemData.TevkifatOran = this.tevkifatkodu.intField / 10
    this.kalemData.TevkifatTutar = this.roundNumber(this.kalemData.KDVTutar * this.kalemData.TevkifatOran,2)
    this.kalemData.KdvID = this.kdvkodu
    this.kalemData.KdvMuafiyetID = this.istisnakodu
    this.kalemData.TevkifatID = this.tevkifatkodu



    var yenikayit = {
      Tutar: this.kalemData.Tutar,
      KDVTutar: this.roundNumber((this.kalemData.Tutar / 100) * this.kalemData.KDVYuzde,2),
      EkVergiTutar: this.roundNumber((this.kalemData.Tutar / 100) * this.kalemData.EkVergiYuzde,2),
      
      KDVliTutar: this.kalemData.Tutar + this.kalemData.KDVTutar,
      PNR_No: this.secilenKalem.PNR_No,
      IslemRef: this.secilenKalem.IslemRef,
      TevkifatOran: this.tevkifatkodu.intField / 10,
      TevkifatTutar: this.roundNumber(this.kalemData.KDVTutar * this.kalemData.TevkifatOran,2),
      KdvID: this.kdvkodu,
      KdvMuafiyetID: this.istisnakodu,
      TevkifatID: this.tevkifatkodu,
      KDVYuzde: this.kalemData.KDVYuzde,
      EkVergiYuzde:this.kalemData.EkVergiYuzde
    }




    this.IadeFatura.Fatura.Kalemler.push(yenikayit);
    this.satirdialog = false
    this.diptopla();
  }



  //kaydetme işlemi
  function Kaydet(tip) {


    if (this.$refs.formgelenfatura.validate()) {



      if (this.GelenFatura.Fatura.Satici.kod != null) {


        if (this.GelenFatura.Fatura.Kalemler.length > 0) {

          this.loadingdialog = true
          this.GelenFatura.KayitTipi = tip
          this.GelenFatura.Fatura.SaticiKod = this.GelenFatura.Fatura.Satici.kod
          let params = this.GelenFatura
          tool.http_post(this, 'GelenFaturaKaydet', params).then(
            response => {
              this.loadingdialog = false

              if (response.body.Status == true) {
                this.text1 = 'Kayıt işlemi tamamlandı'
                this.snackbar = true


                this.git(response.body.data)
                this.GelenFatura.Fatura = response.body.data

                if (tip == '1') {

                  this.GelenFatura.EskiFatura.SaticiTip = response.body.data.SaticiTip
                  this.GelenFatura.EskiFatura.SaticiKod = response.body.data.SaticiKod
                  this.GelenFatura.EskiFatura.FatSeri = response.body.data.FatSeri
                  this.GelenFatura.EskiFatura.FatNo = response.body.data.FatNo
                  this.GelenFatura.EskiFatura.FatTarih = this.GelenFatura.Fatura.FatTarih
                }




                this.GelenFatura.KayitTipi = 2
                this.islemtipi = 1
                this.guncellebuton = true
                this.kaydetbuton = false


              } else {
                this.text1 = response.body.ErrorList[0]
                this.snackbar = true

              }
            },


            response => {
              this.text1 = 'Hata Oluştu, tekrar deneyiniz'
              this.snackbar = true
              this.loadingdialog = false
            }
          );

        } else {
          this.text1 = this.$t('Please-add-items')
          this.snackbar = true

        }

      } else {
        this.text1 = this.$t('Please-select-seller')
        this.snackbar = true

      }
    } else {

      this.text1 = this.$t('Please-fill-required-fields');
      this.snackbar = true

    }

  }


  function faturasil() {

    this.$refs.onaydialog.open('Bu faturayı silmek istediğinize emin misiniz?', 1).then(
      sonuc => {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (sonuc == true) {
          let params = {
            SaticiTip: this.GelenFatura.Fatura.SaticiTip,
            SaticiKod: this.GelenFatura.Fatura.SaticiKod,
            FatSeri: this.GelenFatura.Fatura.FatSeri,
            FatNo: this.GelenFatura.Fatura.FatNo,
            FatTarih: this.GelenFatura.Fatura.FatTarih
          }

          tool.http_post(this, 'GelenFaturaSil', params).then(

            response => {

              if (response.body.Status == true) {


                this.text1 = 'Faturanız silindi.'
                this.snackbar = true

                var url = '#/coper/page/formlar/gelenfaturalistesi'
                setTimeout(function () {
                  window.open(url, '_self')
                }.bind(this), 6000)


              } else {

                this.text1 = response.body.ErrorList[0]
                this.snackbar = true

              }

            },

            response => {

              this.text1 = 'Hata Oluştu, tekrar deneyiniz'

              this.snackbar = true

            }

          );



        }
      });





  }


  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }

  function iskontooranhesapla() {
    var params1 = {
      Tutar: this.SerbestFaturaDetay.Tutar,
      IskontoTutar: this.SerbestFaturaDetay.IskontoTutar
    }

    this.$http.post(auth.API_URL + 'api/Helpers/GetDiscountRate', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.SerbestFaturaDetay.IskontoTutar = response.body.IskontoOran
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      }
    })
  }





  function getDateNow1() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }
    today = dd + '.' + mm + '.' + yyyy
    return today
  }

 

  function beforeMount() {


  }

 

  function toDateformat(dateStr) {
    var parts = dateStr.split("-");
    return (parts[2] + '.' + parts[1] + '.' + parts[0]);
  }



</script>

<style>
  .outer {

    position: relative;
    display: inline-block;
    margin: 0 10px;
    padding-top: inherit+100px;

  }

  .inner {
    position: absolute;
    top: 104%;
    left: 50%;
    padding-block-start: 30px;
    padding-block-end: 10px;
  }

  .icorta {
    margin: 0px auto;
    height: 226px;
    color: #fff;
    position: absolute;
    left: 92%;
    top: 95%;
    margin-left: -110px;
    margin-top: -15px;
  }

  .rotate {
    -moz-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
    -webkit-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
    transform: translateX(-50%) translateY(-50%) rotate(-90deg);

  }
</style>